webpackJsonp([27],{

/***/ 188:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__vuex__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui__);








// import getStore from '../util/index.js'
var CancelToken = __WEBPACK_IMPORTED_MODULE_5_axios___default.a.CancelToken;

// axios.defaults.timeout = 50000
__WEBPACK_IMPORTED_MODULE_5_axios___default.a.defaults.headers.common['APP-ENV'] = '';
__WEBPACK_IMPORTED_MODULE_5_axios___default.a.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

var cancel = void 0;
var resolveHandel;
var sessionExpiredHandling = false;
var SESSION_EXPIRED_FLAG = 'dbSessionExpiredHandled';
// const baseUrl = '//jkw.bjsdcx.com' //http://47.93.8.185:6080
//const baseUrl = '//10.20.251.63:8028'//http://47.93.8.185:6080
var baseUrl = typeof cfg !== 'undefined' && cfg.apiBaseUrl ? cfg.apiBaseUrl : '//' + cfg.host + ':' + cfg.port; //http://47.93.8.185:6080
// const baseUrl = '//u2otvad.nat.ipyingshe.com'
// const baseUrl = '//uwygiq.natappfree.cc'
// const baseUrl = '//127.0.0.1:8028'//http://47.93.8.185:6080
// const baseUrl = '//localhost:8028/'

var appEnv = {
  sign: '',
  token: ''
};
var sign = localStorage.getItem('sign');
var token = localStorage.getItem('token');
var ssoPrefix = typeof cfg !== 'undefined' && cfg.ssoPrefix ? cfg.ssoPrefix : '';
var ssoApiBaseUrl = typeof cfg !== 'undefined' && cfg.ssoApiBaseUrl ? cfg.ssoApiBaseUrl : '';
var ssoTokenBaseUrl = typeof cfg !== 'undefined' && cfg.ssoTokenBaseUrl ? cfg.ssoTokenBaseUrl : '';
var healthSiteAjaxOrigin = typeof cfg !== 'undefined' && cfg.healthSiteAjaxOrigin ? cfg.healthSiteAjaxOrigin : '';
var memberCenterApiOrigin = 'https://member.healthoo.com/prod-api';
// let headerobj = {
//     sign:localStorage.getItem('sign'),
//     token:localStorage.getItem('token'),
//     userId:localStorage.getItem('userId'),
//     credenceUnique:localStorage.getItem('credenceUnique')
// }
// function setAppEnv() {
//     axios.defaults.headers.common['APP-ENV'] = params(appEnv)
// }
// setAppEnv()

function params(json) {
  var s = [];
  function add(key, value) {
    value = Object.prototype.toString.call(value) === '[object Function]' ? '' : value == null ? '' : value;
    s[s.length] = encodeURIComponent(key) + '=' + encodeURIComponent(value);
  }

  function buildParams(prefix, obj) {
    var name;

    if (Object.prototype.toString.call(obj) === '[object Array]') {
      for (var i = 0, j = obj.length; i < j; i++) {
        var v = obj[i];
        buildParams(prefix + '[' + ((typeof v === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(v)) === 'object' ? i : '') + ']', v);
      }
    } else if ((typeof obj === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(obj)) === 'object') {
      for (name in obj) {
        buildParams(prefix + '[' + name + ']', obj[name]);
      }
    } else {
      add(prefix, obj);
    }
  }

  if (!json || typeof json === 'string') {
    return json || '';
  } else {
    for (var p in json) {
      buildParams(p, json[p]);
    }
  }
  return s.join('&').replace(/%20/g, '+');
}

var appFetchOption = {};

function hasHandledSessionExpired() {
  if (typeof window === 'undefined') {
    return false;
  }

  try {
    return window.sessionStorage.getItem(SESSION_EXPIRED_FLAG) === '1';
  } catch (e) {
    return false;
  }
}

function shouldBlockByExpiredFlag() {
  return !!(!localStorage.getItem('token') && hasHandledSessionExpired());
}

function resolveBridgeOrigin() {
  if (typeof cfg !== 'undefined' && cfg.authLoginOrigin) {
    return cfg.authLoginOrigin.replace(/\/$/, '');
  }
  if (typeof window !== 'undefined' && (window.location.hostname === 'healthoo.net' || window.location.hostname === 'www.healthoo.net')) {
    return 'https://member.healthoo.com';
  }
  return 'https://member.healthoo.com';
}

function resolveBridgeEnv() {
  if (typeof window !== 'undefined' && (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1')) {
    return 'local';
  }
  if (typeof window !== 'undefined' && (window.location.hostname === 'healthoo.net' || window.location.hostname === 'www.healthoo.net')) {
    return 'prod';
  }
  return 'test';
}

function clearIamBridgeToken(tokenKey) {
  if (typeof window === 'undefined' || typeof document === 'undefined' || !tokenKey) {
    return;
  }

  var bridgeOrigin = resolveBridgeOrigin();
  var bridgeUrl = new URL(bridgeOrigin + '/authLogin/');
  bridgeUrl.searchParams.set('bridgeMode', '1');
  bridgeUrl.searchParams.set('bridgeEnv', resolveBridgeEnv());
  bridgeUrl.searchParams.set('_t', Date.now());

  var iframe = document.createElement('iframe');
  iframe.src = bridgeUrl.toString();
  iframe.setAttribute('aria-hidden', 'true');
  iframe.style.width = '0';
  iframe.style.height = '0';
  iframe.style.border = '0';
  iframe.style.position = 'absolute';
  iframe.style.left = '-9999px';
  iframe.style.top = '-9999px';
  document.body.appendChild(iframe);

  var bridgeWindow = iframe.contentWindow;
  if (!bridgeWindow) {
    if (iframe.parentNode) {
      iframe.parentNode.removeChild(iframe);
    }
    return;
  }

  var requestId = 'db_expired_clear_' + Date.now() + '_' + Math.random().toString(36).slice(2, 10);
  var settled = false;
  var cleanup = function cleanup() {
    if (settled) {
      return;
    }
    settled = true;
    window.clearTimeout(timeoutTimer);
    window.clearInterval(postTimer);
    window.removeEventListener('message', handleMessage);
    if (iframe.parentNode) {
      iframe.parentNode.removeChild(iframe);
    }
  };
  var postRequest = function postRequest() {
    try {
      bridgeWindow.postMessage({
        action: 'iam-clear-biz-token',
        requestId: requestId,
        tokenKey: tokenKey,
        source: tokenKey === 'dfbitToken' ? 'health' : 'db',
        forceAll: true,
        bridgeEnv: resolveBridgeEnv()
      }, bridgeOrigin);
    } catch (error) {}
  };
  var handleMessage = function handleMessage(event) {
    var data = event.data || {};
    if (event.origin !== bridgeOrigin || event.source !== bridgeWindow || data.action !== 'iam-biz-token-cleared' || data.requestId !== requestId) {
      return;
    }
    cleanup();
  };

  window.addEventListener('message', handleMessage);
  var postTimer = window.setInterval(postRequest, 500);
  var timeoutTimer = window.setTimeout(cleanup, 4000);
  postRequest();
}

function clearIamBridgeTokensOnDbExpired() {
  // 数据库网非手动退出/登录态过期时，也清除 IAM 中相关快捷登录记录。
  clearIamBridgeToken('sysdbToken');
  clearIamBridgeToken('dfbitToken');
}

function handleSessionExpired(message, context) {
  if (sessionExpiredHandling) {
    return;
  }

  sessionExpiredHandling = true;
  var expiredMessage = message || '用户信息已过期或已被其他用户登录,请重新登录';

  localStorage.removeItem('token');
  localStorage.removeItem('sign');
  localStorage.removeItem('authToken');
  localStorage.removeItem('authGk');
  localStorage.removeItem('dmiToken');
  clearIamBridgeTokensOnDbExpired();

  __WEBPACK_IMPORTED_MODULE_6__vuex__["a" /* default */].commit('SetuserInfo', null);
  __WEBPACK_IMPORTED_MODULE_6__vuex__["a" /* default */].commit('ChangeIslogin', false);
  __WEBPACK_IMPORTED_MODULE_6__vuex__["a" /* default */].commit('ChangeLoginStatus', false);
  __WEBPACK_IMPORTED_MODULE_6__vuex__["a" /* default */].commit('SetQueryData', {});
  __WEBPACK_IMPORTED_MODULE_6__vuex__["a" /* default */].commit('SaveDownloadData', {});

  if (typeof window !== 'undefined') {
    try {
      window.sessionStorage.setItem(SESSION_EXPIRED_FLAG, '1');
    } catch (e) {}
    __WEBPACK_IMPORTED_MODULE_7_element_ui__["Message"].closeAll();
    __WEBPACK_IMPORTED_MODULE_7_element_ui__["Message"].error(expiredMessage);
  }
}

function isSessionExpiredResponse(res) {
  return !!(res && (res.error == 700 || res.errorCode == 700 || res.code == 700));
}

function shouldHandleSessionExpired(url, res) {
  if (!isSessionExpiredResponse(res)) {
    return false;
  }

  var token = localStorage.getItem('token');
  if (!token) {
    return false;
  }

  if (typeof url === 'string' && url.indexOf('api/auth/getMessageCount') > -1) {
    return false;
  }

  return true;
}

var api = {
  params: params,
  baseUrl: baseUrl,
  all: __WEBPACK_IMPORTED_MODULE_5_axios___default.a.all,
  setFetchOption: function setFetchOption() {
    var opt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    appFetchOption = opt;
  },
  setConfig: function setConfig(resHandel) {
    resHandel && (resolveHandel = resHandel);
  },
  fetchGet: function fetchGet(url) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      if (shouldBlockByExpiredFlag()) {
        reject('用户信息已过期或已被其他用户登录,请重新登录');
        return;
      }
      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(url, {
        headers: {
          Authorization: localStorage.getItem('token')
        },
        params: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, appFetchOption, params),
        cancelToken: new CancelToken(function (c) {
          cancel = c;
        })
      }).then(function (res) {
        //console.log(res)
        //resolveHandel && resolveHandel(res.data)
        if (shouldHandleSessionExpired(url, res.data)) {
          handleSessionExpired(res.data.message || res.data.msg);
          reject(res.data.message || res.data.msg || '用户信息已过期或已被其他用户登录,请重新登录');
          return;
        }
        if (res.data.error == 0 || res.data.errorCode == 0) {
          resolve(res.data.data);
        } else {
          reject(res.data.message);
        }
      }).catch(function (error) {
        console.log(error);
        if (__WEBPACK_IMPORTED_MODULE_5_axios___default.a.isCancel(error)) {
          console.warn('Request canceled', url, error.message);
        } else {
          reject('网络连接失败！');
        }
      });
    });
  },
  fetchGetRaw: function fetchGetRaw(url) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      if (shouldBlockByExpiredFlag()) {
        reject('用户信息已过期或已被其他用户登录,请重新登录');
        return;
      }
      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(url, {
        headers: {
          Authorization: localStorage.getItem('token')
        },
        params: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, appFetchOption, params),
        cancelToken: new CancelToken(function (c) {
          cancel = c;
        })
      }).then(function (res) {
        if (shouldHandleSessionExpired(url, res.data)) {
          handleSessionExpired(res.data.message || res.data.msg);
          reject(res.data.message || res.data.msg || '用户信息已过期或已被其他用户登录,请重新登录');
          return;
        }
        resolve(res.data);
      }).catch(function (error) {
        console.log(error);
        if (__WEBPACK_IMPORTED_MODULE_5_axios___default.a.isCancel(error)) {
          console.warn('Request canceled', url, error.message);
        } else {
          reject('网络连接失败！');
        }
      });
    });
  },
  fetchSsoGetRaw: function fetchSsoGetRaw(url) {
    var _this = this;

    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var requestUrl = url;
      var queryString = params ? _this.params(params) : '';
      if (queryString) {
        requestUrl += (requestUrl.indexOf('?') > -1 ? '&' : '?') + queryString;
      }
      fetch(requestUrl, {
        method: 'GET'
      }).then(function (response) {
        return response.json();
      }).then(function (res) {
        resolve(res);
      }).catch(function () {
        reject('网络连接失败！');
      });
    });
  },
  fetchPostRaw: function fetchPostRaw(url) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      if (shouldBlockByExpiredFlag()) {
        reject('用户信息已过期或已被其他用户登录,请重新登录');
        return;
      }
      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post(url, params, {
        headers: {
          Authorization: localStorage.getItem('token')
        },
        cancelToken: new CancelToken(function (c) {
          cancel = c;
        })
      }).then(function (res) {
        if (shouldHandleSessionExpired(url, res.data)) {
          handleSessionExpired(res.data.message || res.data.msg);
          reject(res.data.message || res.data.msg || '用户信息已过期或已被其他用户登录,请重新登录');
          return;
        }
        resolve(res.data);
      }).catch(function (error) {
        if (__WEBPACK_IMPORTED_MODULE_5_axios___default.a.isCancel(error)) {
          console.warn('Request canceled', url, error.message);
        } else {
          reject('网络连接失败！');
        }
      });
    });
  },
  fetchPost: function fetchPost(url) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      if (shouldBlockByExpiredFlag()) {
        reject('用户信息已过期或已被其他用户登录,请重新登录');
        return;
      }
      // if (params instanceof FormData) {
      //     for (var p in appFetchOption) {
      //         params.append(p, appFetchOption[p])
      //     }
      // } else {
      // params = {
      //        userId: userId,
      //     // ...appFetchOption,
      //        params
      // }
      // params.Object.assign()
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(params);
      // }
      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post(url, params, {
        headers: {
          Authorization: localStorage.getItem('token')
        },
        cancelToken: new CancelToken(function (c) {
          cancel = c;
        })
      }).then(function (res) {
        resolveHandel && resolveHandel(res.data);
        if (shouldHandleSessionExpired(url, res.data)) {
          handleSessionExpired(res.data.message || res.data.msg);
          reject(res.data.message || res.data.msg || '用户信息已过期或已被其他用户登录,请重新登录');
          return;
        }
        if (res.data.error == 0) {
          resolve(res.data.data, res);
        } else {
          reject(res.data.message);
        }
      }).catch(function (error) {
        if (__WEBPACK_IMPORTED_MODULE_5_axios___default.a.isCancel(error)) {
          console.warn('Request canceled', url, error.message);
        } else {
          reject('网络连接失败！');
        }
      });
    });
  },
  getBaseConfig: function getBaseConfig(params) {
    return this.fetchPost(baseUrl + "/api/config/base", params);
  },

  // 登陆
  userLogin: function userLogin(params) {
    return this.fetchPost(baseUrl + "/api/userLogin", params).then(function (res) {
      // this.setConfig({ token: res.token, })
      return res;
    });
  },

  //手机验证登录
  phoneLogin: function phoneLogin(params) {
    return this.fetchPost(baseUrl + "/api/phoneLogin", params).then(function (res) {
      // this.setConfig({ token: res.token, })
      return res;
    });
  },

  //获取token
  getToken: function getToken(params) {
    return this.fetchGet(baseUrl + "/api/auth/getToken", params).then(function (res) {
      //this.setConfig({ token: '' })
      sign = res.sign;
      token = res.token;
      return res;
    });
  },

  // loginOut(params) {
  //     return this.fetchGet(`${baseUrl}/api/auth/logout`, params).then((res) => {
  //         //this.setConfig({ token: '' })
  //         return res
  //     })
  // },
  cancelAjax: function cancelAjax() {
    if (cancel) {
      cancel('中断请求！');
    }
  },
  getSsoLoginUrl: function getSsoLoginUrl(params) {
    return this.fetchSsoGetRaw(ssoApiBaseUrl || "" + baseUrl + ssoPrefix + "/sso/auth/getUrl", params);
  },
  getSsoToken: function getSsoToken(params) {
    return this.fetchSsoGetRaw(ssoTokenBaseUrl || "" + baseUrl + ssoPrefix + "/sso/auth/getToken", params);
  },
  exchangeHealthSiteToken: function exchangeHealthSiteToken(params) {
    return this.fetchPostRaw(healthSiteAjaxOrigin + "/api/sso/third/login", params).then(function (res) {
      return res;
    });
  },
  verifyMemberCenterPhoneCode: function verifyMemberCenterPhoneCode(params) {
    return this.fetchGetRaw(memberCenterApiOrigin + "/health/api/phone/verifyCode", params).then(function (res) {
      return res;
    });
  },
  checkMemberCenterPhoneCode: function checkMemberCenterPhoneCode(params) {
    return this.fetchGetRaw(memberCenterApiOrigin + "/health/api/phone/check", params).then(function (res) {
      return res;
    });
  },
  verifyMemberCenterEmailCode: function verifyMemberCenterEmailCode(params) {
    return this.fetchGetRaw(memberCenterApiOrigin + "/health/api/email/verifyCode", params).then(function (res) {
      return res;
    });
  },
  checkMemberCenterEmailCode: function checkMemberCenterEmailCode(params) {
    return this.fetchGetRaw(memberCenterApiOrigin + "/health/api/email/check", params).then(function (res) {
      return res;
    });
  },
  exchangeDbSiteToken: function exchangeDbSiteToken(params) {
    return this.fetchPostRaw(baseUrl + "/api/sso/thirdLogin", params).then(function (res) {
      return res;
    });
  },
  crossKeySave: function crossKeySave(key, value) {
    return fetch('/prod-api/permit/all/api/token/save', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ key: key, value: value })
    }).then(function (r) {
      return r.json();
    });
  },
  crossKeyGet: function crossKeyGet(key) {
    return fetch('/prod-api/permit/all/api/token/' + encodeURIComponent(key)).then(function (r) {
      return r.json();
    });
  },
  crossKeyDelete: function crossKeyDelete(key) {
    return fetch('/prod-api/permit/all/api/token/' + encodeURIComponent(key), { method: 'DELETE' }).then(function (r) {
      return r.json();
    });
  },
  fetchGetDmi: function fetchGetDmi(url) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var dmiToken = localStorage.getItem('dmiToken');
      var exchangeToken = function exchangeToken() {
        var currentToken = localStorage.getItem('token');
        if (!currentToken) {
          reject('未登录');
          return;
        }
        __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post('/prod-api/api/sso/third/login', {
          thirdType: 'sysdb',
          clientType: 'WEB',
          thirdToken: currentToken
        }, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: currentToken
          }
        }).then(function (exchangeRes) {
          if (exchangeRes.data && exchangeRes.data.code === 200 && exchangeRes.data.token) {
            localStorage.setItem('dmiToken', exchangeRes.data.token);
            __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(url, {
              headers: {
                Authorization: exchangeRes.data.token
              },
              params: params,
              cancelToken: new CancelToken(function (c) {
                cancel = c;
              })
            }).then(function (res) {
              resolve(res.data);
            }).catch(function () {
              reject('网络连接失败');
            });
          } else {
            reject(exchangeRes.data && (exchangeRes.data.message || exchangeRes.data.msg) || 'token兑换失败');
          }
        }).catch(function (err) {
          reject('token兑换失败');
        });
      };
      if (dmiToken) {
        __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(url, {
          headers: {
            Authorization: dmiToken
          },
          params: params,
          cancelToken: new CancelToken(function (c) {
            cancel = c;
          })
        }).then(function (res) {
          if (res.data && (res.data.error == 401 || res.data.code == 401)) {
            localStorage.removeItem('dmiToken');
            exchangeToken();
          } else {
            resolve(res.data);
          }
        }).catch(function (error) {
          reject('网络连接失败');
        });
      } else {
        exchangeToken();
      }
    });
  },
  sendResetPasswordSmsCode: function sendResetPasswordSmsCode(params) {
    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post('/iam/api/v1/user/password_reset/sms-code/send?dryRun=false', params, {
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(function (res) {
        resolve(res.data);
      }).catch(function (error) {
        reject('网络连接失败！');
      });
    });
  },
  resetPasswordBySms: function resetPasswordBySms(params) {
    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post('/iam/api/v1/user/password-reset', params, {
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(function (res) {
        resolve(res.data);
      }).catch(function (error) {
        reject('网络连接失败！');
      });
    });
  },
  getDmiUserInfo: function getDmiUserInfo() {
    return this.fetchGetDmi('/prod-api/getInfo').then(function (res) {
      return res;
    });
  },
  getAccountConf: function getAccountConf(params) {
    return this.fetchGetDmi("/prod-api/api/business/contacts/findAccountConf/" + params.contactsId).then(function (res) {
      return res;
    });
  },
  getBindQrcode: function getBindQrcode(params) {
    return this.fetchGetDmi("/prod-api/api/business/contacts/bind/qrcode", params).then(function (res) {
      return res;
    });
  },
  checkQrcodeState: function checkQrcodeState(params) {
    return this.fetchGetDmi("/prod-api/api/business/contacts/bind/qrcode/state", params).then(function (res) {
      return res;
    });
  },
  unbindAccount: function unbindAccount(params) {
    return this.fetchGetDmi("/prod-api/api/business/contacts/unbind", params).then(function (res) {
      return res;
    });
  },
  bindQcAccount: function bindQcAccount(params) {
    return this.fetchGetDmi("/prod-api/api/business/contacts/bind/qc", params).then(function (res) {
      return res;
    });
  }
};
[['downloadFile', 'api/downloadFile']].forEach(function (item) {
  api[item[0]] = function (data) {
    console.log(baseUrl);
    return baseUrl + "/" + item[1] + "?Authorization=" + localStorage.getItem('token') + params(data);
  };
});

[['wechat', 'api/social/wechat'], ['qq', 'api/social/qq'], ['weibo', 'api/social/weibo']].forEach(function (item) {
  api[item[0]] = function (data) {
    console.log(baseUrl);
    return baseUrl + "/" + item[1];
  };
});

// get
[

// 首页-tab切换
// ['tabSwitchApi', 'api/index'],
// 首页-search搜索
['search', 'api/index/search'],
// 详情-search-details
['medicines', 'api/medicines'],
// page
['page', 'api/page'], ['getAdList', 'api/getAdList'], ['tree', 'api/tree'],
// ['getPageInfo','api/getPageInfo?tableName=select_zgypdq'],
// 获取右侧数据
['getPageInfo', 'api/getPageInfo'], ['getCascaderChildren', 'api/getCascaderChildren'],
// 详情-表格
['medicinesList', 'api/medicinesList'],
//用户名登录
// ['userLogin','api/userLogin'],
//获取用户信息
['getUserInfo', 'api/auth/getUserInfo'],
//第三方登录-获取用户信息
['getUserInfoByCode', 'api/social/getUserInfoByCode'],
//获取token
// ['getToken','api/auth/getToken'],
//个人中心-系统消息计数
['getMessageCount', 'api/auth/getMessageCount'], ['getVipLevelList', 'api/auth/getVipLevelList'], ['getBkList', 'api/auth/getBkList'],
//个人中心-系统消息列表
['getMessageList', 'api/auth/getMessageList'],
//个人中心-子账号列表
['getAccountList', 'api/auth/account/list'],
//发票列表
['getReceiptList', 'api/auth/getReceiptList'],
//个人中心-积分管理
['getIntegralList', 'api/auth/getIntegralList'],
//个人中心-订单管理
['getOrderList', 'api/auth/getOrderList'],
//个人中心-合同管理
['getAgreementList', 'api/auth/getAgreementList'],
//获取详细消息
['getMessageDetail', 'api/auth/getMessageDetail'],
//获取发票内容类型
['getReceiptContentList', 'api/getReceiptContentList'], ['getIntegralRadio', 'api/getIntegralRatio'],
//下载资料
['fileDownload', 'api/fileDownload'], ['checkRegister', 'api/checkRegister'],
//查询文档
['tabsearch', 'api/index'],
//计算订单价格
['discountIntegral', 'api/auth/discountIntegral'], ['logoOut', 'api/auth/logOut'],
//支付宝支付
// ['alipay','api/aliPay'],
['weChatPay', 'api/weChatPay'], ['getOrderStatus', 'api/auth/getOrderStatus'],
//获取订单信息
['getOrder', 'api/auth/getOrder'], ['computeReceiptAmount', 'api/auth/computeReceiptAmount'],
// 首页搜索建议
['associationList', 'api/associationList'], ['getTreeFirst', 'api/getTreeFirst'],
//服务介绍以及走马灯
['getWalkingList', 'api/walking/getWalkingList'],
//获取左侧树高亮
['tableNameByName', 'api/tableNameByName'], ['checkPassword', 'api/auth/check/password'], ['getSdkDoc', 'api/sdk/getSdkDoc']].forEach(function (item) {
  api[item[0]] = function (params) {
    return api.fetchGet(baseUrl + "/" + item[1], params);
  };
});
// post
[
// 注册
['register', 'api/register'],
// 忘记密码
['forgetPassword', 'api/forgetPassword'],
//发送验证码
['sendCode', 'api/sendCode'], ['bindUserInfo', 'api/auth/bindUserInfo'],
//修改手机号
['resetPhone', 'api/auth/resetPhone'],
//修改密码
['updateUserInfo', 'api/auth/updateUserInfo'],
//个人中心-服务项目
//个人中心-添加发票抬头
['addReceiptHead', 'api/auth/addReceipt'],
//单条数据添加已读
['readMessage', 'api/auth/readMessage'], ['deleteMessage', 'api/auth/deleteMessage'], ['deleteAccount', 'api/auth/account/deleteAccount'], ['addAccount', 'api/auth/account/add'], ['updateAccount', 'api/auth/account/update'],
//全部已读
['readAllMessage', 'api/auth/readAllMessage'], ['resetPassword', 'api/auth/resetPassword'],
//修改个人信息
//上传头像
['updateUserHead', 'api/auth/updateUserHead'],
//创建订单
['createOrder', 'api/auth/createOrder'], ['uptateOrderStatus', 'api/auth/uptateOrderStatus'], ['pay', 'api/auth/pay'],
// 右侧搜索按钮
['pageSearch', 'api/pageSearch'],
// 右侧统计
['pageSearchSum', 'api/pageSearchSum'], ['pageSearchEchart', 'api/pageSearchEchart']].forEach(function (item) {
  api[item[0]] = function (params) {
    return api.fetchPost(baseUrl + "/" + item[1], params);
  };
});

/* harmony default export */ __webpack_exports__["a"] = (api);

/***/ }),

/***/ 327:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_header__ = __webpack_require__(664);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_footer__ = __webpack_require__(776);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      adsList: {},
      adsLeftShow: true,
      adsRightShow: true,
      adsBotoomShow: true
    };
  },

  components: {
    Header: __WEBPACK_IMPORTED_MODULE_0__common_header__["a" /* default */],
    Footer: __WEBPACK_IMPORTED_MODULE_1__common_footer__["a" /* default */]
  },
  mounted: function mounted() {
    this.getAdsList();
  },

  methods: {
    getAdsList: function getAdsList() {
      var _this = this;

      this.api.getAdList().then(function (res) {
        _this.adsList = res;
        // console.log(res)
      }).catch(function (err) {
        console.log(err);
      });
    }
  },
  computed: {
    hideHeaderFooter: function hideHeaderFooter() {
      return location.href.indexOf("payGateWay") != -1;
    }
  }
});

/***/ }),

/***/ 328:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_tabs__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_level__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_IamLoginModal__ = __webpack_require__(690);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    var _this2 = this;

    var validateUser = function validateUser(rule, value, callback) {
      console.log("user");
      if (value === "") {
        callback(new Error("请输入账号"));
      } else {
        callback();
      }
    };

    // 用户注册
    var validatePhone = function validatePhone(rule, value, callback) {
      console.log("手机");
      if (value === "") {
        callback(new Error("请输入手机号"));
      } else if (!/^1[3|4|5|6|7|8|9][0-9]\d{4,8}$/.test(value)) {
        callback(new Error("手机号格式不正确"));
      } else {
        callback();
      }
    };
    // 用户注册
    var validateRegisterPhone = function validateRegisterPhone(rule, value, callback) {
      if (value === "") {
        callback(new Error("请输入手机号"));
      } else if (!/^1[3|4|5|6|7|8|9][0-9]\d{4,8}$/.test(value)) {
        callback(new Error("手机号格式不正确"));
      } else {
        _this2.api.checkRegister({ phone: value }).then(function (res) {
          if (res == true) {
            callback();
          } else {
            callback("手机号已被注册");
          }
        });
      }
    };
    var validateCode = function validateCode(rule, value, callback) {
      console.log("验证码");
      if (value === "") {
        callback(new Error("请输入验证码"));
      } else {
        // if (this.logonForm.checkPass !== '') {
        //   this.$refs.logonForm.validateField('checkPass')
        // }
        callback();
      }
    };
    // 登录验证
    var validatePassLogin = function validatePassLogin(rule, value, callback) {
      if (value === "") {
        callback(new Error("请输入密码"));
      }
      // ('(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])(?=.*[^a-zA-Z0-9]).{8,30}')
      // else if (!/^(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])(?=.*[^a-zA-Z0-9]).{8,30}$/.test(value)) {
      //   callback(
      //     new Error("密码中必须包含大写字母、小写字母、数字、特殊字符")
      //   );
      // }
      else {
          callback();
        }
    };
    /* 注册忘记密码 密码验证 */
    /*var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else if (
        !/^(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])(?=.*[^a-zA-Z0-9]).{8,30}$/.test(
          value
        )
      ) {
        callback(new Error("密码中必须包含大写字母、小写字母、数字、特殊字符"));
      } else {
        callback();
      }
    }; */

    var validatePass = function validatePass(rule, value, callback) {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else if (!/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,16}$/.test(value)) {
        callback(new Error("密码中必须包含6-16位字母和数字组合"));
      } else {
        callback();
      }
    };

    var validatePassTwo = function validatePassTwo(rule, value, callback) {
      if (value === "") {
        callback(new Error("请确认密码"));
      } else if (_this2.logonForm.passTwo !== _this2.logonForm.pass) {
        // if (this.ruleForm.passTwo !== this.ruleForm.pass) {
        callback(new Error("两次输入密码不一致"));
        // }
      } else {
        callback();
      }
    };
    var validateClause = function validateClause(rule, value, callback) {
      if (value === "" || value === false) {
        callback(new Error("请选择服务条款、隐私政策"));
      } else {
        callback();
      }
    };
    return {
      noReadMessage: 0,
      // dialogTableVisible: false,
      registerVisible: false,
      forgetPwdVisible: false,
      count: 0,
      countText: "获取验证码",
      countText2: "获取验证码",
      codestatus: false,
      ruleForm: {
        user: "",
        code: "",
        passLogin: ""
      },
      logonPhoneForm: {
        phone: "",
        code: ""
      },
      logonForm: {
        phone: "",
        code: "",
        pass: "",
        passTwo: "",
        clause: false
      },
      forgetPwdForm: {
        phone: "",
        code: "",
        pass: "",
        passTwo: ""
      },
      rules: {
        user: [{ validator: validateUser, trigger: "blur", required: true }],
        phone: [{ validator: validatePhone, trigger: "blur", required: true }],
        code: [{ validator: validateCode, trigger: "blur", required: true }],
        passLogin: [{ validator: validatePassLogin, trigger: "blur", required: true }],
        pass: [{ validator: validatePass, trigger: "blur", required: true }],
        passTwo: [{ validator: validatePassTwo, trigger: "blur", required: true }]
      },
      registerRules: {
        user: [{ validator: validateUser, trigger: "blur", required: true }],
        phone: [{ validator: validateRegisterPhone, trigger: "blur", required: true }],
        code: [{ validator: validateCode, trigger: "blur", required: true }],
        passLogin: [{ validator: validatePassLogin, trigger: "blur", required: true }],
        pass: [{ validator: validatePass, trigger: "blur", required: true }],
        passTwo: [{ validator: validatePassTwo, trigger: "blur", required: true }],
        clause: [{ validator: validateClause, trigger: "blur" }]
      },
      z: 0,
      showCodelogin: false,
      logintypetxt: "手机号快捷登录",
      showcenter: false
    };
  },
  created: function created() {},

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_8_vuex__["b" /* mapState */])({
    userInfo: function userInfo(state) {
      return state.userInfo;
    },
    islogin: function islogin(state) {
      return state.islogin;
    },
    dialogTableVisible: function dialogTableVisible(state) {
      return state.showLogin;
    },
    downloadData: function downloadData(state) {
      return state.downloadData;
    },
    queryData: function queryData(state) {
      return state.queryData;
    }
  })),
  mounted: function mounted() {
    this.loadMessageCount();
    if (this.$route.query && this.$route.query.openLogin === "1") {
      this.$store.commit("ChangeLoginStatus", true);
      this.$router.replace({
        path: this.$route.path,
        query: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, this.$route.query, { openLogin: undefined })
      });
    }
    // if(!localStorage.getItem('islogin')){
    //   this.registerVisible = false;
    // }
    // this.showcenter = this.islogin
  },

  methods: {
    loadMessageCount: function loadMessageCount() {
      var _this3 = this;

      this.api.getMessageCount().then(function (res) {
        _this3.noReadMessage = res.notReadCounts;
      }).catch(function (error) {});
    },
    handleIamLoginSuccess: function handleIamLoginSuccess(userInfo) {
      this.$store.commit("SetuserInfo", userInfo);
      this.$store.commit("ChangeLoginStatus", false);
      this.loadMessageCount();
      this.submitOrder();
    },
    forgotPass: function forgotPass() {
      this.forgetPwdVisible = true;
      // this.dialogTableVisible = false;
      this.$store.commit("ChangeLoginStatus", false);
    },
    loginWechatFun: function loginWechatFun() {
      var params = this.$route.query;
      var paramsStr = "";
      for (var key in params) {
        paramsStr = paramsStr + "@" + key + "=" + params[key];
        console.log(key, params[key]);
      }
      // debugger;
      window.open(this.api.wechat() + "?url=" + this.$route.path + "~" + paramsStr, "_self");
    },
    loginQqFun: function loginQqFun() {
      console.log("qq登录");
      window.open(this.api.qq(), "_self");
    },
    loginWeiboFun: function loginWeiboFun() {
      console.log("微博登录");
      window.open(this.api.weibo(), "_self");
    },

    //登录
    loginAction: function loginAction() {
      // this.dialogTableVisible = true;
      this.$store.commit("ChangeLoginStatus", true);
    },


    //退出
    logoOut: function logoOut() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var frame, oldKey;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this4.$message({
                  message: "退出登录成功",
                  type: "success"
                });
                try {
                  frame = window.__bridgeFrame;

                  if (frame && frame.contentWindow) {
                    frame.contentWindow.postMessage({ action: "sso-clear", tokenKey: "sysdbToken" }, "*");
                  }
                } catch (e) {}
                try {
                  sessionStorage.setItem("ssoAutoSuppressed", "true");
                } catch (e) {}
                _this4.$store.commit("SetuserInfo", {});
                _this4.$store.commit("ChangeIslogin", false);
                localStorage.removeItem("token");
                localStorage.removeItem("sign");
                localStorage.removeItem("authToken");
                localStorage.removeItem("authGk");
                localStorage.removeItem("dmiToken");
                // 跨站 SSO：退出时删除 crossKey
                oldKey = localStorage.getItem("crossKey");

                if (oldKey) {
                  __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].crossKeyDelete(oldKey).catch(function () {});
                  localStorage.removeItem("crossKey");
                }
                _this4.showcenter = false;
                _this4.$router.push("/");
                _this4.$store.commit("SetQueryData", {});
                _this4.$store.commit("SaveDownloadData", {});
                window.location.reload();

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this4);
      }))();
    },
    goRegister: function goRegister() {
      this.openIamRegister();
    },
    getRuntimeConfig: function getRuntimeConfig() {
      console.log(cfg);
      if (typeof cfg !== "undefined") {
        return cfg;
      }
      return {};
    },
    resolveAuthLoginOrigin: function resolveAuthLoginOrigin() {
      var runtimeConfig = this.getRuntimeConfig();
      if (runtimeConfig.authLoginOrigin) {
        return runtimeConfig.authLoginOrigin.replace(/\/$/, "");
      }
      if (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1") {
        return "http://127.0.0.1:3321";
      }
      return window.location.origin;
    },
    resolveRegisterBaseUrl: function resolveRegisterBaseUrl(loginPageUrl) {
      if (loginPageUrl) {
        try {
          var loginUrl = new URL(loginPageUrl, window.location.origin);
          return loginUrl.origin + "/authLogin/RegisterMain";
        } catch (error) {}
      }
      return this.resolveAuthLoginOrigin() + "/authLogin/RegisterMain";
    },
    goHealthSite: function goHealthSite() {
      var curCrossKey = localStorage.getItem("crossKey");
      var url = "https://www.healthoo.com/";
      if (curCrossKey) {
        url += "?crossKey=" + encodeURIComponent(curCrossKey);
      }
      window.open(url, "_blank");
    },
    openIamRegister: function openIamRegister() {
      var _this5 = this;

      var runtimeConfig = this.getRuntimeConfig();
      var returnUrl = new URL(runtimeConfig.appBase || "/", window.location.origin).toString();

      this.api.getSsoLoginUrl().then(function (res) {
        if (!(res && (res.code === 200 || res.error === 0) && res.data)) {
          _this5.$message.error(res && (res.msg || res.message) || "获取注册参数失败");
          return;
        }

        var registerUrl = new URL(_this5.resolveRegisterBaseUrl(res.data.loginPageUrl));
        registerUrl.searchParams.append("source", "db");
        registerUrl.searchParams.append("returnUrl", returnUrl);
        if (res.data.authUrl) {
          registerUrl.searchParams.append("authUrl", res.data.authUrl);
        }
        if (res.data.clientId) {
          registerUrl.searchParams.append("clientId", res.data.clientId);
        }
        if (res.data.callbackUrl) {
          registerUrl.searchParams.append("callbackUrl", res.data.callbackUrl);
        }
        if (res.data.state) {
          registerUrl.searchParams.append("state", res.data.state);
        }
        registerUrl.searchParams.append("_t", Date.now());
        window.open(registerUrl.toString(), "_blank");
      }).catch(function (error) {
        _this5.$message.error(error || "获取注册参数失败");
      });
    },
    goLogin: function goLogin() {
      // this.dialogTableVisible = true;
      this.registerVisible = false;
      this.forgetPwdVisible = false;
      this.$store.commit("ChangeLoginStatus", true);
    },
    closeDialog: function closeDialog() {
      this.$store.commit("ChangeLoginStatus", false);
    },

    //切换登录
    loginSwitch: function loginSwitch() {
      this.showCodelogin = !this.showCodelogin;
      if (this.showCodelogin == false) {
        this.logintypetxt = "手机号快捷登录";
      } else {
        this.logintypetxt = "账号密码登录";
      }
      //this.showCodelogin==false?this.logintypetxt = '手机号快捷登录':this.logintypetxt = '账号密码登录'
    },

    //发送验证码
    sendCode: function sendCode(phone, type) {
      var _this6 = this;

      var dataobj = {
        phone: phone,
        type: type
      };
      this.api.sendCode(dataobj).then(function (res) {
        console.log("验证码请求：", res);
        if (res.length) {
          //返回文字
          _this6.$message.error(res);
        } else {
          _this6.$message({
            message: "验证码发送成功，请注意查收",
            type: "success"
          });
          // debugger;
          _this6.count = 60;
          _this6.codestatus = true;
          var time = setInterval(function () {
            if (_this6.count <= 0) {
              clearInterval(time);
              _this6.codestatus = false;
              _this6.countText = "获取验证码";
            } else {
              _this6.count = _this6.count - 1;
              _this6.countText = "\u8FD8\u5269" + _this6.count + "\u79D2";
            }
          }, 1000);
        }
      }).catch(function (error) {});
    },
    CationCode2: function CationCode2(logonPhoneForm) {
      var _this7 = this;

      console.log("滑块验证码...");

      this.$refs.logonPhoneForm.validateField("phone", function (valid) {
        if (!valid) {
          _this7.sendCode(_this7.logonPhoneForm.phone, 1);
          _this7.count = 60;
          _this7.codestatus = true;
          var time = setInterval(function () {
            if (_this7.count <= 0) {
              clearInterval(time);
              _this7.codestatus = false;
              _this7.countText2 = "获取验证码";
            } else {
              _this7.count = _this7.count - 1;
              _this7.countText2 = "\u8FD8\u5269" + _this7.count + "\u79D2";
            }
          }, 1000);
        } else {
          return false;
        }
      });
    },

    // 注册获取验证码
    CationCode: function CationCode(logonForm) {
      var _this8 = this;

      this.$refs.logonForm.validateField("phone", function (valid) {
        if (!valid) {
          _this8.sendCode(_this8.logonForm.phone, 2);
        } else {
          return false;
        }
      });
    },

    // 忘记密码获取验证码
    CationCode3: function CationCode3(logonForm) {
      var _this9 = this;

      this.$refs.forgetPwdForm.validateField("phone", function (valid) {
        if (!valid) {
          if (_this9.sendCode(_this9.forgetPwdForm.phone, 3)) {
            _this9.count = 60;
            _this9.codestatus = true;
            var time = setInterval(function () {
              if (_this9.count <= 0) {
                clearInterval(time);
                _this9.codestatus = false;
                _this9.countText = "获取验证码";
              } else {
                _this9.count = _this9.count - 1;
                _this9.countText = "\u8FD8\u5269" + _this9.count + "\u79D2";
              }
            }, 1000);
          }
        } else {
          return false;
        }
      });
    },
    submitForm: function submitForm(formName) {
      var _this10 = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          alert("submit!");
        } else {
          // console.log('error submit!!')
          _this10.api.register().then(function (res) {}).catch(function (err) {
            console.log(err);
          });
          return false;
        }
      });
    },
    logonSubmitForm: function logonSubmitForm(formName) {
      var _this11 = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          //alert("submit!");
          _this11.api.register({
            phone: _this11.logonForm.phone,
            code: _this11.logonForm.code,
            password: _this11.logonForm.pass,
            surePassword: _this11.logonForm.passTwo
          }).then(function (res) {
            _this11.$message({
              message: "注册成功",
              type: "success"
            });
            _this11.registerVisible = false;
            _this11.loginAction();
          }).catch(function (err) {
            console.log(err);
            _this11.$message.error(err);
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    forgetPwdSubmitForm: function forgetPwdSubmitForm(formName) {
      var _this12 = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          //alert("submit!");
          _this12.api.forgetPassword({
            phone: _this12.forgetPwdForm.phone,
            code: _this12.forgetPwdForm.code,
            password: _this12.forgetPwdForm.pass,
            surePassword: _this12.forgetPwdForm.passTwo
          }).then(function (res) {
            _this12.$message({
              message: "找回密码成功",
              type: "success"
            });
            console.log(res);
            _this12.forgetPwdVisible = false;
            _this12.loginAction();
          }).catch(function (err) {
            console.log(err);
            _this12.$message.error(err);
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    //登录
    registerSubmitForm: function registerSubmitForm(formName) {
      var _this13 = this;

      var _this = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          var postdata = {
            phone: _this13.ruleForm.user,
            password: _this13.ruleForm.passLogin
          };
          var phonedata = {
            phone: _this13.logonPhoneForm.phone,
            code: Number(_this13.logonPhoneForm.code)
          };

          //let storageobj = {}
          if (_this13.showCodelogin == false) {
            // 账号密码登录
            _this13.api.userLogin(postdata).then(function (res) {
              _this13.$message({
                message: "登录成功",
                type: "success"
              });
              _this.$store.commit("SetuserInfo", res);
              localStorage.setItem("token", res.token);
              localStorage.removeItem("dmiToken");
              _this.$store.commit("ChangeLoginStatus", false);
            }).then(function () {
              _this.submitOrder();
            }).catch(function (error) {
              _this13.$message.error(error);
            });
          } else {
            // 手机快捷登录
            _this13.api.phoneLogin(phonedata).then(function (res) {
              _this13.$message({
                message: "登录成功",
                type: "success"
              });
              _this.$store.commit("SetuserInfo", res);
              localStorage.setItem("token", res.token);
              localStorage.removeItem("dmiToken");
              _this.$store.commit("ChangeLoginStatus", false);
            }).then(function () {
              _this.submitOrder();
            }).catch(function (error) {
              _this13.$message.error(error);
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    //提交订单
    submitOrder: function submitOrder() {
      var _this14 = this;

      console.log("进入提交订单方法，还未提交");
      // 下载文件或者下载数据有数据时
      if (this.downloadData) {
        console.log("存在订单数据");
        if (this.downloadData.orderType == 4 || this.downloadData.orderType == 2) {
          this.api.createOrder(this.downloadData).then(function (res) {
            console.log(res);
            var routeData = _this14.$router.resolve({
              path: "/ShoppingCart",
              query: {
                orderno: res.orderNo
              }
            });
            window.open(routeData.href, "_blank");
          }).catch(function (error) {
            console.log(error);
            _this14.$message.error("服务器出了小差，请重新搜索数据");
          });
        } else {
          this.api.pageSearch(this.queryData).then(function (res) {
            // orderType == 2 下载文件 orderType == 1 下载数据
            if (_this14.downloadData.fileIds && _this14.downloadData.orderType == 2 || _this14.downloadData.downloadColumn && _this14.downloadData.orderType == 1 || _this14.downloadData.orderType == 4) {
              _this14.api.createOrder(_this14.downloadData).then(function (res) {
                console.log(res);
                var routeData = _this14.$router.resolve({
                  path: "/ShoppingCart",
                  query: {
                    orderno: res.orderNo
                  }
                });
                window.open(routeData.href, "_blank");
              }).catch(function (error) {
                console.log(error);
                _this14.$message.error("服务器出了小差，请重新搜索数据");
              });
            } else {
              console.tablelog("不满足订单创建条件");
            }
          });
        }
      } else {
        this.$router.go(0);
      }
    },

    //获取token
    getToken: function getToken(data) {
      console.log("获取token方法");
      var postdata = {
        credenceUnique: data
      };
      this.api.getToken(postdata).then(function (res) {
        localStorage.setItem("token", res.token);
        localStorage.setItem("sign", res.sign);
        localStorage.removeItem("dmiToken");
      }).catch(function (error) {});
    },
    resetForm: function resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  },
  components: {
    Tabs: __WEBPACK_IMPORTED_MODULE_4__common_tabs__["a" /* default */],
    Level: __WEBPACK_IMPORTED_MODULE_5__common_level__["a" /* default */],
    IamLoginModal: __WEBPACK_IMPORTED_MODULE_6__common_IamLoginModal__["a" /* default */]
  }
});

/***/ }),

/***/ 334:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import { mapState } from "vuex";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["plate"],
  name: "tabs",
  data: function data() {
    return {
      directory: [
        // {
        //   link: "/page/table?plate=1&tableName=select_zgypdq",
        //   img: "static/images/zonghe.png",
        //   imgActive: "static/images/zonghe_a.png",
        //   title: "产品名录",
        //   plate: 1
        // },
        // {
        //   link: "/page/table?plate=3&tableName=select_ypxscytj",
        //   img: "static/images/baogao.png",
        //   imgActive: "static/images/baogao_a.png",
        //   title: "自助报告",
        //   plate: 3
        // },
        // {
        //   link: "/page/table?plate=4&tableName=select_yplssc@1",
        //   img: "static/images/yaopin.png",
        //   imgActive: "static/images/yaopin_a.png",
        //   title: "药品零售",
        //   plate: 4
        // },
        // {
        //   link: "/page/table?plate=5&tableName=select_jcklztjk",
        //   img: "static/images/haiwai.png",
        //   imgActive: "static/images/haiwai_a.png",
        //   title: "海外市场",
        //   plate: 5
        // },
        // {
        //   link: "/page/table?plate=2&tableName=select_ylyjylcs",
        //   img: "static/images/api.png",
        //   imgActive: "static/images/api_a.png",
        //   title: "原料药供销",
        //   plate: 2
        // },
        // {
        //   link: "/page/download?plate=6&tableName=select_file@1",
        //   img: "static/images/ziliao.png",
        //   imgActive: "static/images/ziliao_a.png",
        //   title: "资料下载",
        //   plate: 6
        // },
        // {
        //   link: "/page/table?plate=1&tableName=select_yllssgsyj",
        //   img: "static/images/zhibiao.png",
        //   imgActive: "static/images/zhibiao_a.png",
        //   title: "指标查询",
        //   plate: 7
        // }
      ],
      active: [0, 0, 0, 0, 0, 0, 0, 0],
      activePageList: [] //最后一级面包屑
    };
  },

  watch: {
    directory: function directory(val) {}
  },
  mounted: function mounted() {
    var _this2 = this;

    var _this = this;
    this.api.getTreeFirst().then(function (res) {
      _this2.directory = res.plateList;
      _this2.activePageList = res.firstTitle;
      _this2.$nextTick(function () {
        _this2.$set(_this2.active, _this2.activeIndex, 1);
      });
    }).catch(function (error) {});
  },

  methods: {
    normalizeTabImage: function normalizeTabImage(src) {
      if (!src) {
        return src;
      }
      if (/^(https?:)?\/\//.test(src) || /^data:/.test(src)) {
        return src;
      }
      var appBase = window.cfg && window.cfg.appBase || "/";
      if (appBase.charAt(appBase.length - 1) !== "/") {
        appBase += "/";
      }
      if (src.indexOf(appBase) === 0) {
        return src;
      }
      var normalizedSrc = src.charAt(0) === "/" ? src.slice(1) : src;
      return appBase + normalizedSrc;
    },
    setActive: function setActive(index) {
      this.active = [0, 0, 0, 0, 0, 0, 0, 0];
      this.$set(this.active, index, 1);
      this.$store.commit("SetActivePage", this.activePageList[index]);
      localStorage.removeItem('urlActiveName');
      localStorage.removeItem('urlActive');
      // let title="";
      // if(this.activeIndex!=-1){
      //   title=this.directory[this.activeIndex].title;
      // }
      // console.log(title);
      // this.$store.commit("SetActivePath",title);
    }
  },
  computed: {
    staticImageBase: function staticImageBase() {
      var appBase = window.cfg && window.cfg.appBase || "/";
      if (appBase.charAt(appBase.length - 1) !== "/") {
        appBase += "/";
      }
      return appBase + "static/images/";
    },

    activeIndex: function activeIndex() {
      var activeList = this.directory.map(function (item) {
        return item.plate;
      });
      return activeList.indexOf(this.plate / 1);
    },
    isHome: function isHome() {
      return this.$route.path === "/";
    }
    // ...mapState({
    //   plate: state => state.plate
    // }),

  }
});

/***/ }),

/***/ 335:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 336:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(685);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);

//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    n: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      ImgLink: '',
      level: [{ ordinary: 1 }, { whole: 2 }, { gold: 3 }, { platinum: 4 }, { diamonds: 5 }, { vip: 6 }]
    };
  },
  mounted: function mounted() {
    this.ruleFun(this.n);
  },

  methods: {
    ruleFun: function ruleFun(e) {
      var _this = this;

      this.level.map(function (v, i) {
        if (v[__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(v)[0]] === e) {
          _this.ImgLink = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(v)[0];
        }
      });
    }
  }
});

/***/ }),

/***/ 337:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api__ = __webpack_require__(188);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "IamLoginModal",
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  created: function created() {
    var self = this;
    this._boundAuthLoginMessage = function (e) {
      self.handleAuthLoginMessage(e);
    };
  },
  data: function data() {
    return {
      loginUrl: "",
      loadingText: "正在加载登录页面...",
      tokenEventSource: null,
      tokenStreamAbortController: null,
      currentState: "",
      tokenSubscriptionStarted: false,
      loginFrameOrigin: ""
    };
  },

  watch: {
    visible: function visible(newVal) {
      if (newVal) {
        if (!this.loginUrl) {
          this.initLogin();
        } else {
          window.addEventListener("message", this._boundAuthLoginMessage);
        }
      }
    }
  },
  mounted: function mounted() {

    // ====== 跨站 SSO：检查 URL 是否带 crossKey ======
    var self = this;
    var crossKey = this.getUrlParam("crossKey");
    console.log("[777 db] mounted crossKey from URL:", crossKey);
    console.log("[777 db] mounted window.location.href:", window.location.href);
    if (crossKey) {
      // 立即清掉 URL crossKey 参数（同时更新 Vue Router 内部状态）
      try {
        var u = new URL(window.location.href);
        console.log("[777 db] before replaceState:", u.toString());
        u.searchParams.delete("crossKey");
        if (this.$router) {
          var q = {};
          u.searchParams.forEach(function (v, k) {
            q[k] = v;
          });
          this.$router.replace({ path: window.location.pathname, query: q });
        } else {
          window.history.replaceState({}, "", u.toString());
        }
        console.log("[777 db] after replaceState:", window.location.href);
      } catch (e) {
        console.log("[777 db] replaceState error:", e);
      };
      // 已登录则跳过
      try {
        var existingToken = localStorage.getItem("token");
        console.log("[777 db] existingToken:", existingToken ? "yes" : "no");
        if (existingToken) {
          return;
        }
      } catch (e) {}

      console.log("[777 db] calling crossKeyGet for key:", crossKey);
      __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].crossKeyGet(crossKey).then(function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee(data) {
          var value, payload, token, source, result;
          return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  console.log("[777 db] crossKeyGet response:", __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(data));
                  value = data && (data.value || data.data);

                  if (value) {
                    _context.next = 6;
                    break;
                  }

                  console.log("[777 db] crossKeyGet no value, preloadLogin");self.preloadLogin();return _context.abrupt("return");

                case 6:
                  try {
                    payload = JSON.parse(value);
                  } catch (e) {
                    payload = value;
                  }
                  console.log("[777 db] crossKeyGet payload:", __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(payload));
                  token = payload && (payload.token || payload.value);
                  source = payload && payload.source;

                  if (token) {
                    _context.next = 14;
                    break;
                  }

                  console.log("[777 db] crossKeyGet no token, preloadLogin");self.preloadLogin();return _context.abrupt("return");

                case 14:
                  console.log("[777 db] crossKeyGet token found, source:", source, "token length:", token.length);

                  // auto-login

                  if (!(source === "health")) {
                    _context.next = 26;
                    break;
                  }

                  console.log("[777 db] source=health, calling exchangeDfbitToken");
                  _context.next = 19;
                  return self.exchangeDfbitToken(token);

                case 19:
                  result = _context.sent;

                  console.log("[777 db] exchangeDfbitToken result:", __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(result));

                  if (!(!result || !result.success)) {
                    _context.next = 24;
                    break;
                  }

                  self.preloadLogin();
                  return _context.abrupt("return");

                case 24:
                  _context.next = 29;
                  break;

                case 26:
                  console.log("[777 db] source=db, calling handleTokenReceived");
                  _context.next = 29;
                  return self.handleTokenReceived({ token: token });

                case 29:
                  console.log("[777 db] calling clearCrossKeyUrl, href before:", window.location.href);
                  self.clearCrossKeyUrl();
                  console.log("[777 db] href after clearCrossKeyUrl:", window.location.href);

                case 32:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }()).catch(function (err) {
        console.log("[777 db] crossKeyGet error:", err);
        self.preloadLogin();
      });
      return;
    } else {
      console.log("[777 db] no crossKey in URL, href:", window.location.href);
    }

    this.preloadLogin();
    // 永久监听 iam-login-submit（QQ登录从新窗口回调，不依赖 visible）
    window.addEventListener("message", this._boundAuthLoginMessage);

    // ====== 调试：监控 URL 变化 ======
    var lastHref = window.location.href;
    setInterval(function () {
      var cur = window.location.href;
      if (cur !== lastHref) {
        console.log("[777 db] URL changed from:", lastHref, "to:", cur);
        lastHref = cur;
      }
    }, 500);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener("message", this._boundAuthLoginMessage);
    this.teardownTokenSubscription();
  },

  methods: {
    handleClose: function handleClose() {
      this.teardownTokenSubscription();
      this.$emit("close");
    },
    resetState: function resetState() {
      this.teardownTokenSubscription();
      this.loginUrl = "";
      this.currentState = "";
      this.tokenSubscriptionStarted = false;
      this.loadingText = "正在加载登录页面...";
      this.loginFrameOrigin = "";
    },

    // ====== 预加载登录 iframe（页面加载后立即执行，隐藏 iframe）======
    preloadLogin: function preloadLogin() {
      var _this = this;

      if (this.loginUrl) {
        return;
      }
      __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].getSsoLoginUrl().then(function (res) {
        if (res && (res.code === 200 || res.error === 0) && res.data) {
          _this.loginUrl = _this.buildLoginUrl(res.data);
          _this.loginFrameOrigin = new URL(_this.loginUrl).origin;
          _this.currentState = res.data.state || "";
          _this.$nextTick(function () {
            if (_this.$refs.loginFrame) {
              window.__bridgeFrame = _this.$refs.loginFrame;
            }
          });
        } else {}
      }).catch(function (err) {});
    },

    // ====== 接收 iframe 发来的 iam-login-submit 信号（QQ登录从新窗口回调）======
    handleAuthLoginMessage: function handleAuthLoginMessage(event) {
      var loginFrameWindow = this.$refs && this.$refs.loginFrame && this.$refs.loginFrame.contentWindow ? this.$refs.loginFrame.contentWindow : null;

      if (!event || !event.data || event.data.action !== "iam-login-submit") {
        return;
      }
      // QQ登录是弹出新窗口，回调页发给 opener（iframe）→ iframe 转发给父页面
      // 即使 modal 不可见（预加载模式），也要处理
      if (this.tokenSubscriptionStarted || !this.currentState) {
        return;
      }
      this.tokenSubscriptionStarted = true;
      this.subscribeToken(this.currentState);
    },


    // ====== 跨站 SSO crossKey ======
    generateCrossKey: function generateCrossKey(token) {
      var raw = (token || "").replace(/^Bearer\s+/i, "");
      var prefix = raw.slice(0, 16);
      var encoded = btoa(prefix + ":" + Date.now()).replace(/=/g, "");
      var key = encoded.slice(0, 40);
      return key;
    },
    crossKeySave: function crossKeySave(key, value) {
      return __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].crossKeySave(key, value).then(function (json) {
        return json;
      });
    },
    crossKeyDelete: function crossKeyDelete(key) {
      return __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].crossKeyDelete(key).then(function (json) {
        return json;
      });
    },
    generateCrossKeyAndSave: function generateCrossKeyAndSave(token, userInfo) {
      var normalizedToken = (token || "").trim().replace(/^Bearer\s+/i, "");
      if (!normalizedToken) {
        return;
      }
      var crossKey = this.generateCrossKey(normalizedToken);
      var oldKey = localStorage.getItem("crossKey");
      var self = this;
      var p = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve();
      var payload = { token: normalizedToken, source: "db" };
      if (userInfo) {
        payload.userInfo = {
          userName: userInfo.userName || "",
          phonenumber: userInfo.phonenumber || userInfo.phone || "",
          userId: userInfo.userId || ""
        };
      }
      if (oldKey && oldKey !== crossKey) {
        p = this.crossKeyDelete(oldKey).catch(function (err) {});
      }
      return p.then(function () {
        return self.crossKeySave(crossKey, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(payload));
      }).then(function (res) {
        localStorage.setItem("crossKey", crossKey);
        return res;
      }).catch(function (err) {});
    },


    // ====== 工具函数 ======
    clearCrossKeyUrl: function clearCrossKeyUrl() {
      console.log("[777 db] clearCrossKeyUrl called, href before:", window.location.href);
      try {
        var u = new URL(window.location.href);
        console.log("[777 db] clearCrossKeyUrl parsed URL search:", u.search);
        u.searchParams.delete("crossKey");
        // 通过 Vue Router replace 更新 query，保证 this.$route.query 同步更新
        if (this.$router) {
          var q = {};
          u.searchParams.forEach(function (v, k) {
            q[k] = v;
          });
          this.$router.replace({ path: window.location.pathname, query: q });
        } else {
          window.history.replaceState({}, "", u.toString());
        }
        console.log("[777 db] clearCrossKeyUrl href after:", window.location.href);
      } catch (e) {
        console.log("[777 db] clearCrossKeyUrl error:", e);
      }
    },
    getUrlParam: function getUrlParam(name) {
      var m = window.location.search.match(new RegExp("[?&]" + name + "=([^&]*)"));
      return m ? decodeURIComponent(m[1]) : null;
    },
    getRuntimeConfig: function getRuntimeConfig() {
      if (typeof cfg !== "undefined") {
        return cfg;
      }
      return {};
    },
    resolveAuthLoginOrigin: function resolveAuthLoginOrigin() {
      var runtimeConfig = this.getRuntimeConfig();
      if (runtimeConfig.authLoginOrigin) {
        return runtimeConfig.authLoginOrigin.replace(/\/$/, "");
      }
      if (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1") {
        return "http://127.0.0.1:3321";
      }
      return "http://www.healthoo.com";
    },
    resolveBridgeEnv: function resolveBridgeEnv() {
      var runtimeConfig = this.getRuntimeConfig();
      var authLoginOrigin = runtimeConfig.authLoginOrigin || "";
      var healthSiteOrigin = runtimeConfig.healthSiteOrigin || "";
      var envSource = window.location.hostname + " " + authLoginOrigin + " " + healthSiteOrigin;
      var env = "test";
      if (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1") {
        env = "local";
      } else if (/member\.healthoo\.com|www\.healthoo\.com|(^|\.)healthoo\.net/i.test(envSource)) {
        env = "prod";
      }
      return env;
    },
    normalizeExchangeToken: function normalizeExchangeToken(token) {
      if (!token || typeof token !== "string") {
        return "";
      }
      return token.trim().replace(/^Bearer\s+/i, "");
    },


    // ====== 快捷登录：用 iframe 传来的 token 调后端交换 ======
    exchangeDfbitToken: function exchangeDfbitToken(thirdToken) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var normalizedToken, res, success, code, message, reason;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                normalizedToken = _this2.normalizeExchangeToken(thirdToken);

                if (normalizedToken) {
                  _context2.next = 3;
                  break;
                }

                return _context2.abrupt("return", {
                  success: false,
                  reason: "expired"
                });

              case 3:
                _context2.prev = 3;
                _context2.next = 6;
                return __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].exchangeDbSiteToken({
                  thirdType: "dfbit",
                  clientType: "WEB",
                  thirdToken: normalizedToken
                });

              case 6:
                res = _context2.sent;
                success = !!res && (res.code === 200 || res.error === 0) && (res.token || res.data);

                if (success) {
                  _context2.next = 13;
                  break;
                }

                code = Number(res && (res.code || res.error || res.errorCode));
                message = res && (res.msg || res.message) || "";
                reason = message.indexOf("三方用户信息获取异常") > -1 ? "invalid" : code >= 500 ? "server" : "invalid";
                return _context2.abrupt("return", {
                  success: false,
                  reason: reason
                });

              case 13:
                _context2.next = 15;
                return _this2.handleTokenReceived({
                  token: res.token || res.data,
                  sign: res.sign || ""
                });

              case 15:
                return _context2.abrupt("return", {
                  success: true,
                  reason: ""
                });

              case 18:
                _context2.prev = 18;
                _context2.t0 = _context2["catch"](3);
                return _context2.abrupt("return", {
                  success: false,
                  reason: "network"
                });

              case 21:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[3, 18]]);
      }))();
    },

    // ====== 构建登录 iframe URL ======
    buildLoginUrl: function buildLoginUrl(data) {
      var runtimeConfig = this.getRuntimeConfig();
      var authLoginBaseUrl = this.resolveAuthLoginOrigin() + "/authLogin/";

      if (!runtimeConfig.forceLocalAuthLogin && data.loginPageUrl) {
        authLoginBaseUrl = data.loginPageUrl;
      }

      var authUrlObj = new URL(authLoginBaseUrl);
      if (data.authUrl) {
        authUrlObj.searchParams.append("authUrl", data.authUrl);
      }
      if (data.clientId) {
        authUrlObj.searchParams.append("clientId", data.clientId);
      }
      if (data.callbackUrl) {
        authUrlObj.searchParams.append("callbackUrl", data.callbackUrl);
      }
      if (data.state) {
        authUrlObj.searchParams.append("state", data.state);
      }
      authUrlObj.searchParams.append("response_type", "code");
      authUrlObj.searchParams.append("source", "db");
      authUrlObj.searchParams.append("parentOrigin", window.location.origin);
      authUrlObj.searchParams.append("bridgeEnv", this.resolveBridgeEnv());
      // 跨站 SSO：传递 crossKey 给 iframe
      var crossKey = localStorage.getItem("crossKey");
      if (crossKey) {
        authUrlObj.searchParams.append("crossKey", crossKey);
      } else {}
      authUrlObj.searchParams.append("_t", Date.now());
      var url = authUrlObj.toString();
      return url;
    },


    // ====== 初始化登录 ======
    initLogin: function initLogin() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.teardownTokenSubscription();
                _this3.loginUrl = "";
                _this3.currentState = "";
                _this3.tokenSubscriptionStarted = false;
                _this3.loadingText = "正在加载登录页面...";
                window.removeEventListener("message", _this3._boundAuthLoginMessage);
                window.addEventListener("message", _this3._boundAuthLoginMessage);

                _this3.loadingText = "正在加载登录页面...";
                __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].getSsoLoginUrl().then(function (res) {
                  if (res && (res.code === 200 || res.error === 0) && res.data) {
                    _this3.loginUrl = _this3.buildLoginUrl(res.data);
                    _this3.loginFrameOrigin = new URL(_this3.loginUrl).origin;
                    _this3.currentState = res.data.state || "";
                    return;
                  }
                  _this3.$message.error(res && res.msg || "获取登录链接失败");
                  _this3.handleClose();
                }).catch(function (error) {
                  _this3.$message.error(error || "获取登录链接失败");
                  _this3.handleClose();
                });

              case 9:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    subscribeToken: function subscribeToken(state) {
      if (!state) {
        return;
      }

      this.teardownTokenSubscription();
      this.tokenSubscriptionStarted = true;

      var runtimeConfig = this.getRuntimeConfig();
      var ssoSseUrl = runtimeConfig.ssoSseUrl || "";

      if (!ssoSseUrl || typeof fetch === "undefined") {
        return;
      }

      try {
        var eventUrl = new URL(ssoSseUrl, window.location.origin);
        eventUrl.searchParams.set("state", state);
        this.subscribeTokenByFetch(eventUrl.toString());
      } catch (error) {
        this.teardownTokenSubscription();
      }
    },
    subscribeTokenByFetch: function subscribeTokenByFetch(url) {
      var _this4 = this;

      if (!url || typeof fetch === "undefined") {
        return;
      }

      this.tokenSubscriptionStarted = true;
      this.tokenStreamAbortController = new AbortController();

      fetch(url, {
        method: "GET",
        signal: this.tokenStreamAbortController.signal
      }).then(function (response) {
        if (!response || !response.body || !response.body.getReader) {
          return response.text().then(function (text) {
            _this4.handleFetchStreamText(text);
          });
        }

        var reader = response.body.getReader();
        var decoder = new TextDecoder("utf-8");
        var buffer = "";

        var pump = function pump() {
          return reader.read().then(function (result) {
            if (result.done) {
              _this4.handleFetchStreamText(buffer);
              return;
            }

            buffer += decoder.decode(result.value, { stream: true });

            if (_this4.tryHandleFetchStreamBuffer(buffer)) {
              return;
            }

            return pump();
          });
        };

        return pump();
      }).catch(function () {
        _this4.teardownTokenSubscription();
      });
    },
    tryHandleFetchStreamBuffer: function tryHandleFetchStreamBuffer(buffer) {
      if (!buffer) {
        return false;
      }

      var normalizedBuffer = buffer;
      var dataIndex = normalizedBuffer.indexOf("data:");

      if (dataIndex > -1) {
        normalizedBuffer = normalizedBuffer.slice(dataIndex + 5);
      }

      var startIndex = normalizedBuffer.indexOf("{");
      var endIndex = normalizedBuffer.lastIndexOf("}");

      if (startIndex === -1 || endIndex <= startIndex) {
        return false;
      }

      var jsonText = normalizedBuffer.slice(startIndex, endIndex + 1).trim();

      try {
        var payload = JSON.parse(jsonText);
        if (payload && (payload.token || payload.accessToken || payload.Authorization)) {
          this.teardownTokenSubscription();
          this.handleTokenReceived(payload);
          return true;
        }
      } catch (error) {
        return false;
      }

      return false;
    },
    handleFetchStreamText: function handleFetchStreamText(text) {
      if (!text) {
        this.teardownTokenSubscription();
        return;
      }

      if (!this.tryHandleFetchStreamBuffer(text)) {
        this.teardownTokenSubscription();
      }
    },
    teardownTokenSubscription: function teardownTokenSubscription() {
      if (this.tokenEventSource) {
        this.tokenEventSource.close();
        this.tokenEventSource = null;
      }
      if (this.tokenStreamAbortController) {
        this.tokenStreamAbortController.abort();
        this.tokenStreamAbortController = null;
      }
      this.tokenSubscriptionStarted = false;
    },

    // ====== 新增：等待登录 iframe 确认收到 token ======
    waitForLoginAck: function waitForLoginAck(timeout) {
      timeout = timeout || 1000;
      var self = this;
      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
        function handler(event) {
          if (event.data && event.data.action === "iam-login-acked") {
            window.removeEventListener("message", handler);
            clearTimeout(timer);
            resolve(true);
          }
        }
        var timer = setTimeout(function () {
          window.removeEventListener("message", handler);
          resolve(false);
        }, timeout);
        window.addEventListener("message", handler);
      }).then(function (result) {
        return result;
      });
    },

    // ====== waitForLoginAck 结束 ======

    handleTokenReceived: function handleTokenReceived(tokenPayload) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var token, sign, self;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                token = "";
                sign = "";


                if (typeof tokenPayload === "string") {
                  token = tokenPayload;
                } else if (tokenPayload && (typeof tokenPayload === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(tokenPayload)) === "object") {
                  token = tokenPayload.token || tokenPayload.accessToken || tokenPayload.Authorization || "";
                  sign = tokenPayload.sign || "";
                }

                if (!(!token || typeof token === "string" && (token === "{" || token === "}" || token.indexOf("{") > -1))) {
                  _context5.next = 6;
                  break;
                }

                _this5.handleClose();
                return _context5.abrupt("return");

              case 6:

                _this5.loadingText = "正在校验登录结果...";
                localStorage.setItem("token", token);
                localStorage.removeItem("dmiToken");
                if (sign) {
                  localStorage.setItem("sign", sign);
                }

                _this5.loadingText = "正在获取用户信息...";
                self = _this5;
                return _context5.abrupt("return", __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].getUserInfo().then(function () {
                  var _ref2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee4(userInfo) {
                    var loginFrameWindow, ackResult;
                    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                      while (1) {
                        switch (_context4.prev = _context4.next) {
                          case 0:
                            // 登录成功，关闭弹窗后重置信令重新预加载 iframe
                            // ====== 新方式：直接把 token 传给登录 iframe ======
                            // 旧方式（已废弃）：pushBridgeToken → 创建隐藏 iframe → postMessage
                            // 新方式：当前登录 iframe 还开着，直接传给它，它存到 localStorage
                            loginFrameWindow = self.$refs.loginFrame && self.$refs.loginFrame.contentWindow;

                            if (!loginFrameWindow) {
                              _context4.next = 8;
                              break;
                            }

                            loginFrameWindow.postMessage({
                              action: "iam-login-token",
                              token: token,
                              tokenKey: "sysdbToken",
                              source: "db",
                              sourceLabel: "数据库网",
                              userName: userInfo.userName || "",
                              phone: userInfo.phone || userInfo.phonenumber || "",
                              userId: userInfo.userId || ""
                            }, "*");

                            // 等待 iframe 确认收到
                            _context4.next = 5;
                            return self.waitForLoginAck(1000);

                          case 5:
                            ackResult = _context4.sent;
                            _context4.next = 8;
                            break;

                          case 8:
                            _context4.next = 10;
                            return self.generateCrossKeyAndSave(token, userInfo);

                          case 10:

                            self.loginUrl = "";

                            self.$message.success("登录成功");
                            self.$emit("success", userInfo);
                            self.handleClose();

                          case 14:
                          case "end":
                            return _context4.stop();
                        }
                      }
                    }, _callee4, this);
                  }));

                  return function (_x2) {
                    return _ref2.apply(this, arguments);
                  };
                }()).catch(function (error) {
                  self.$message.error(error || "获取用户信息失败");
                  self.handleClose();
                }).finally(function () {
                  self.preloadLogin();
                }));

              case 13:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this5);
      }))();
    }
  }
});

/***/ }),

/***/ 345:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state__ = __webpack_require__(722);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations__ = __webpack_require__(723);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(724);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__getters__ = __webpack_require__(725);







__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);
// const state={
//     userInfo:{}
// }

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
    state: __WEBPACK_IMPORTED_MODULE_2__state__["a" /* default */],
    getters: __WEBPACK_IMPORTED_MODULE_5__getters__["a" /* default */],
    mutations: __WEBPACK_IMPORTED_MODULE_3__mutations__["a" /* default */],
    actions: __WEBPACK_IMPORTED_MODULE_4__actions__["a" /* default */]
}));

/***/ }),

/***/ 356:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import { openHealthSiteWithDbToken } from "@/utils/healthSite";

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      navListTop: [{
        name: "数据库",
        link: "/"
      }, {
        name: "产业经济",
        link: "http://www.healthoo.com/C8/"
      }, {
        name: "研究报告",
        link: "http://www.healthoo.com/A6/"
      }, {
        name: "终端市场",
        link: "http://www.healthoo.com/C7/"
      }, {
        name: "科研信息",
        link: "http://www.healthoo.com/A8/"
      }, {
        name: "医药原料",
        link: "http://www.healthoo.com/B3/"
      }, {
        name: "国际药业",
        link: "http://www.healthoo.com/A9/"
      }, {
        name: "动物用药",
        link: "http://www.healthoo.com/C5/"
      }, {
        name: "辅料添加剂",
        link: "http://www.healthoo.com/D0/"
      }, {
        name: "图文报告",
        link: "http://www.healthoo.com/A0/"
      }],
      navlist: [{
        name: '首页',
        link: 'http://www.healthoo.com/'
      }, {
        name: '关于健康网',
        link: 'http://www.healthoo.com/C2/200702/C2_20070227110457_312448.asp'
      }, {
        name: '联系我们',
        link: 'http://www.healthoo.com/C2/200702/C2_20070227134705_312464.asp'
      }, {
        name: '入网指南',
        link: 'http://www.healthoo.com/C2/200702/C2_20070227132605_312457.asp'
      }, {
        name: '隐私条款',
        link: '/clause'
      }],
      path: []
    };
  },
  created: function created() {},

  methods: {
    linkFun: function linkFun(e) {
      if (e.name === '首页') {
        this.$router.push({
          path: '/'
        });
      } else if (e.name === '隐私条款') {
        this.$router.push({
          path: '/clause'
        });
      } else {
        var curCrossKey = localStorage.getItem("crossKey");
        var url = e.link || "https://member.healthoo.com/";
        if (curCrossKey && url.indexOf("healthoo.com") > -1) {
          var separator = url.indexOf("?") > -1 ? "&" : "?";
          url += separator + "crossKey=" + encodeURIComponent(curCrossKey);
        } else {}
        window.open(url, "_blank");
      }
    }
  }
});

/***/ }),

/***/ 439:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tabs_vue__ = __webpack_require__(334);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6591f162_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_tabs_vue__ = __webpack_require__(683);
function injectStyle (ssrContext) {
  __webpack_require__(682)
}
var normalizeComponent = __webpack_require__(102)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6591f162"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tabs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6591f162_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_tabs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 440:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_level_vue__ = __webpack_require__(336);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_057bc711_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_level_vue__ = __webpack_require__(689);
function injectStyle (ssrContext) {
  __webpack_require__(684)
}
var normalizeComponent = __webpack_require__(102)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-057bc711"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_level_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_057bc711_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_level_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 441:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(279);
module.exports = __webpack_require__(643);


/***/ }),

/***/ 643:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(650);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App__ = __webpack_require__(661);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__(781);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__vuex_index__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_index_css__ = __webpack_require__(783);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_base_css__ = __webpack_require__(784);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__api_index__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_cookies__ = __webpack_require__(785);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_cookies___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_cookies__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_echarts__ = __webpack_require__(786);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_echarts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_echarts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_axios__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_babel_polyfill__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_qs__ = __webpack_require__(1083);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_qs__);










// import Avue from '@smallwei/avue';
// import '@smallwei/avue/lib/index.css';

//import { setCookie, getCookie, removeCookie, objectDefaults } from './util'

__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_11_vue_cookies___default.a);
__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_element_ui___default.a);
// Vue.use(Avue);
//引入echarts图表库

__WEBPACK_IMPORTED_MODULE_3_vue__["default"].prototype.echarts = __WEBPACK_IMPORTED_MODULE_12_echarts___default.a;
//Vue.prototype.setCookie = setCookie
__WEBPACK_IMPORTED_MODULE_3_vue__["default"].prototype.api = __WEBPACK_IMPORTED_MODULE_10__api_index__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_3_vue__["default"].prototype.baseUrl = __WEBPACK_IMPORTED_MODULE_10__api_index__["a" /* default */].baseUrl;
//引入axios文件



__WEBPACK_IMPORTED_MODULE_3_vue__["default"].prototype.axios = __WEBPACK_IMPORTED_MODULE_13_axios___default.a;
__WEBPACK_IMPORTED_MODULE_3_vue__["default"].prototype.qs = __WEBPACK_IMPORTED_MODULE_15_qs___default.a;
__WEBPACK_IMPORTED_MODULE_3_vue__["default"].prototype.apiUrl = "http://123.57.9.5:6080/";
__WEBPACK_IMPORTED_MODULE_3_vue__["default"].config.productionTip = false;

// ====== 旧互通登录代码（已废弃，由 IamLoginModal 预加载 iframe + tokenBridge 广播替代）======
// var healthDbLoginHandled = false;
// var SESSION_EXPIRED_FLAG = "dbSessionExpiredHandled";
// var allowedHealthMessageOrigins = [...];
// function isHealthHandshakeMode() {...}
// function resolveDbAppTarget(targetUrl) {...}
// function navigateDbAppTarget(targetUrl) {...}
// function runDbPostLoginHooks() {...}
// function handleHealthSiteAutoLogin(payload) {...}
// window.addEventListener("message", ...)
// setupHealthToDbHandshake() {...}
// ====== 结束 ======
window.ty = __WEBPACK_IMPORTED_MODULE_3_vue__["default"].prototype.ty = {
  computeStrWidth: function computeStrWidth(str) {
    var span = document.querySelector('#ty-computeWidth-th');
    span.innerHTML = str;
    return span.offsetWidth;
  },
  sum: function sum(key, arr) {
    return arr.map(function (e) {
      return e[key];
    }).reduce(function (a, b) {
      return a + b;
    }, 0);
  },
  addHeadProperty: {
    width: function width(head, data) {
      //计算各列最大宽度，并赋值个width属性，最大不超过Cons.maxCellWidth
      head = head.map(function (e) {
        e.width = Math.max.apply(Math, [ty.computeStrWidth(e.label) + Cons.sortW].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(data.map(function (ee) {
          return ty.computeStrWidth(ee[e.value]);
        }))));
        //加上el-table .cell>div有左右padding
        e.width += 20;
        if (e.width > Cons.maxCellWidth) {
          e.width = Cons.maxCellWidth;
        }
        return e;
      });
      //获取表头总宽度
      var sumWidth = 0;
      head.map(function (e) {
        return sumWidth += Math.round(e.width);
      });
      try {
        //如果表格所有列宽度加起来，还没占满屏幕。那么就不按这个computeWidth来。
        console.log(sumWidth, document.querySelector('.search-details-wrapper'), document.querySelector('.search-details-wrapper').offsetWidth);
        if (sumWidth < document.querySelector('.search-details-wrapper').offsetWidth - 130) {
          head = head.map(function (e) {
            if (e.label.match(/上市许可持有人|日常监管机构/)) {
              return e;
            }
            delete e.width;
            return e;
          });
        }
      } catch (e) {}
      return head;
    }
  },
  getMenuItem: function getMenuItem(name) {
    var menuData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : vm.$store.state.menuData;

    var getMenuItem = function getMenuItem(name, menuData) {
      var res = null;
      for (var i = 0, I = menuData[i]; I; I = menuData[++i]) {
        if (I.entity.name == name) {
          console.log('ok', JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(I)));
          res = I;
          break;
        }
      }
      if (res == null) {
        for (var _i = 0, _I = menuData[_i]; _I; _I = menuData[++_i]) {
          if (_I.children && _I.children.length) {
            // console.log('入',name,I.children.map(e=>e.entity.name));
            res = getMenuItem(name, _I.children);
            if (res) {
              break;
            }
          }
        }
      }
      return res;
    };
    return getMenuItem(name, menuData);
  }
};
window.Cons = __WEBPACK_IMPORTED_MODULE_3_vue__["default"].prototype.Cons = {
  sortW: 50,
  indexW: 50,
  pageSizes: [10, 20, 30, 40, 50, 100],
  pageSize: 20,
  maxCellWidth: 300,
  plate: 8
};
__WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */].beforeEach(function (to, from, next) {
  if (!__WEBPACK_IMPORTED_MODULE_6__vuex_index__["a" /* default */].state.userInfo) {
    var token = localStorage.getItem("token");
    if (token == null || token == '') {
      var query = '';
      if (window.location.hash != '' && window.location.hash != null) {
        query = window.location.hash.split('?')[1];
      }
      if (query && query != '') {
        var param = "";
        if (query.indexOf("&") > 0) {
          var vars = query.split("&");
          param = {
            code: vars[0].split('=')[1],
            type: vars[1].split('=')[1]
          };
        }
        __WEBPACK_IMPORTED_MODULE_10__api_index__["a" /* default */].getUserInfoByCode(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(param)).then(function (res) {
          __WEBPACK_IMPORTED_MODULE_6__vuex_index__["a" /* default */].commit("SetuserInfo", res);
          localStorage.setItem("token", res.token);
          localStorage.removeItem("dmiToken");
          next();
        }).catch(function (error) {
          next();
          __WEBPACK_IMPORTED_MODULE_6__vuex_index__["a" /* default */].commit("ChangeLoginStatus", false);
        });
      } else {
        if (to.meta.requireAuth) {
          __WEBPACK_IMPORTED_MODULE_6__vuex_index__["a" /* default */].commit("ChangeLoginStatus", true);
          next();
        } else {
          next();
        }
      }
    } else {
      if (to.meta.requireAuth) {
        __WEBPACK_IMPORTED_MODULE_10__api_index__["a" /* default */].getUserInfo().then(function (res) {
          __WEBPACK_IMPORTED_MODULE_6__vuex_index__["a" /* default */].commit("SetuserInfo", res);
          next();
        }).catch(function (error) {
          __WEBPACK_IMPORTED_MODULE_7_element_ui___default.a.Message(error);
          localStorage.removeItem("token");
          localStorage.removeItem("dmiToken");
          __WEBPACK_IMPORTED_MODULE_6__vuex_index__["a" /* default */].commit("ChangeLoginStatus", true);
          next();
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_10__api_index__["a" /* default */].getUserInfo().then(function (res) {
          __WEBPACK_IMPORTED_MODULE_6__vuex_index__["a" /* default */].commit("SetuserInfo", res);
          next();
        }).catch(function (error) {
          __WEBPACK_IMPORTED_MODULE_7_element_ui___default.a.Message(error);
          __WEBPACK_IMPORTED_MODULE_6__vuex_index__["a" /* default */].commit("ChangeLoginStatus", false);
          localStorage.removeItem("token");
          localStorage.removeItem("dmiToken");
          next();
        });
      }
    }
  } else {
    next();
  }
});

// ====== 跨标签同步登录状态 ======
// 当另一个标签页登录或退出时，storage 事件会触发，刷新当前页同步状态
window.addEventListener("storage", function (event) {
  console.log("[777 main.js] storage event fired, key:", event.key, "oldValue:", event.oldValue ? "length " + event.oldValue.length : "null", "newValue:", event.newValue ? "length " + event.newValue.length : "null");
  if (event.key === "token") {
    console.log("[777 main.js] storage event key is token, reloading page");
    window.location.reload();
  }
});

__WEBPACK_IMPORTED_MODULE_3_vue__["default"].directive('title', {
  inserted: function inserted(el, binding) {
    document.title = el.dataset.title;
  }
});

/* eslint-disable no-new */
window.vm = new __WEBPACK_IMPORTED_MODULE_3_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_6__vuex_index__["a" /* default */],
  template: '<App/>',
  components: {
    App: __WEBPACK_IMPORTED_MODULE_4__App__["a" /* default */]
  },
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_4__App__["a" /* default */]);
  }
});

/***/ }),

/***/ 661:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(327);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_979674fc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(780);
function injectStyle (ssrContext) {
  __webpack_require__(662)
}
var normalizeComponent = __webpack_require__(102)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_979674fc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 662:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 664:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_header_vue__ = __webpack_require__(328);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_177058ce_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_header_vue__ = __webpack_require__(775);
function injectStyle (ssrContext) {
  __webpack_require__(665)
}
var normalizeComponent = __webpack_require__(102)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-177058ce"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_177058ce_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 665:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 682:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 683:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container flex",staticStyle:{"justify-content":"center","position":"relative","width":"100%"}},[_c('div',{staticClass:"flex",staticStyle:{"width":"90%"}},[_c('div',{staticStyle:{"width":"200px","text-align":"center"}},[(_vm.isHome)?_c('img',{staticStyle:{"width":"149px","height":"54px","margin-top":"40px"},attrs:{"src":__webpack_require__(335),"alt":""}}):_c('img',{staticStyle:{"width":"110px","height":"40px","margin-top":"4px"},attrs:{"src":__webpack_require__(335),"alt":""}})]),_vm._v(" "),_c('ul',{staticClass:"ul-wrapper",class:{home: _vm.isHome},staticStyle:{"flex":"1"},style:({maxWidth: _vm.isHome?'auto':'auto'})},[_vm._l((_vm.directory),function(item,index){return _c('li',{key:index,staticClass:"li-item",on:{"click":function($event){return _vm.setActive(index)}}},[_c('router-link',{attrs:{"to":item.link}},[_c('div',{staticClass:"son"},[_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.active[index]),expression:"active[index]"}],attrs:{"src":_vm.normalizeTabImage(item.imgActive)}}),_vm._v(" "),_c('img',{directives:[{name:"show",rawName:"v-show",value:(!_vm.active[index]),expression:"!active[index]"}],attrs:{"src":_vm.normalizeTabImage(item.img)}}),_vm._v(" "),_c('span',{class:_vm.active[index]?'isActive':''},[_vm._v(_vm._s(item.title))])])])],1)}),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.directory.length),expression:"directory.length"}],staticClass:"li-item",on:{"click":function($event){return _vm.setActive(7)}}},[_c('router-link',{attrs:{"to":"/table2?plate="+_vm.Cons.plate+"&tableName=select_api"}},[_c('div',{staticClass:"son"},[_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.active[7]),expression:"active[7]"}],attrs:{"src":_vm.staticImageBase + 'sjjk_a.png'}}),_vm._v(" "),_c('img',{directives:[{name:"show",rawName:"v-show",value:(!_vm.active[7]),expression:"!active[7]"}],attrs:{"src":_vm.staticImageBase + 'sjjk.png'}}),_vm._v(" "),_c('span',{class:_vm.active[7]?'isActive':''},[_vm._v(_vm._s('数据接口'))])])])],1)],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 684:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 689:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"level-wrapper"},[(_vm.ImgLink !== '')?_c('img',{attrs:{"src":'../../static/images/' + _vm.ImgLink + '.png'}}):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 690:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IamLoginModal_vue__ = __webpack_require__(337);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9b95a4d2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IamLoginModal_vue__ = __webpack_require__(774);
function injectStyle (ssrContext) {
  __webpack_require__(691)
}
var normalizeComponent = __webpack_require__(102)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9b95a4d2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IamLoginModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9b95a4d2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IamLoginModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 691:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 722:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
  // openId: '23333',
  // myOpenId: 'okITM5ib6-AUE3Ycri_8zmMaFdmw',
  userInfo: null,
  islogin: false,
  //登录弹窗
  showLogin: false,
  JSSDK: null,
  iconChartActive: [0, 0, 0, 1],
  activePath: "",
  activePage: "",
  isCollapse: false,
  tableName: "",
  menuData: [],
  curApi: {},
  apiFirstTable: ''
  // plate:0,
};

var getters = {
  //实时监听state值的变化(最新状态)
  getOpenid: function getOpenid(state) {
    //方法名随意,主要是来承载变化的showFooter的值
    return state.openId;
  },
  getJSSDK: function getJSSDK(state) {
    return state.JSSDK;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (state);

/***/ }),

/***/ 723:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// import { start } from "repl";

var matutaions = {
  SetOpenid: function SetOpenid(state, NewOpenid) {
    //方法名随意,主要是来承载变化的showFooter的值
    state.openId = NewOpenid;
  },
  SetuserInfo: function SetuserInfo(state, userInfo) {
    //方法名随意,主要是来承载变化的showFooter的值
    state.userInfo = userInfo;
    state.islogin = true;
  },
  ChangeIslogin: function ChangeIslogin(state, status) {
    state.islogin = status;
  },
  ChangeLoginStatus: function ChangeLoginStatus(state, status) {
    state.showLogin = status;
  },
  SetJSSDK: function SetJSSDK(state, jssdkData) {
    state.JSSDK = jssdkData;
  },
  SetIconChartActive: function SetIconChartActive(state, iconChartActive) {
    state.iconChartActive = iconChartActive;
  },
  SetActivePath: function SetActivePath(state, activePath) {
    state.activePath = activePath;
  },
  SetActivePage: function SetActivePage(state, activePage) {
    state.activePage = activePage;
  },
  SetCollapseMenu: function SetCollapseMenu(state, isCollapse) {
    state.isCollapse = isCollapse;
  },
  SetTableName: function SetTableName(state, tableName) {
    state.tableName = tableName;
  },
  SetQueryData: function SetQueryData(state, status) {
    state.queryData = status;
  },

  // SetPlate(state,plate){
  //   state.plate=plate;
  // }
  // 保存下载数据
  SaveDownloadData: function SaveDownloadData(state, downloadData) {
    state.downloadData = downloadData;
  },
  menuData: function menuData(state, _menuData) {
    state.menuData = _menuData;
  },
  curApi: function curApi(state, _curApi) {
    state.curApi = _curApi;
  },
  apiFirstTable: function apiFirstTable(state, _apiFirstTable) {
    state.apiFirstTable = _apiFirstTable;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (matutaions);

/***/ }),

/***/ 724:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var actions = {
  SetOpenid: function SetOpenid(context) {
    //自定义触发mutations里函数的方法，context与store 实例具有相同方法和属性
    context.commit('SetOpenid');
  },
  Setjssdk: function Setjssdk(context, data) {
    //同上注释，num为要变化的形参
    context.commit('SetJSSDK', data);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (actions);

/***/ }),

/***/ 725:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var getters = {
  //实时监听state值的变化(最新状态)
  getOpenid: function getOpenid(state) {
    //方法名随意,主要是来承载变化的showFooter的值
    return state.openId;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (getters);

/***/ }),

/***/ 774:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"iam-login-modal",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }return _vm.handleClose($event)}}},[_c('div',{staticClass:"iam-login-modal__panel"},[_c('button',{staticClass:"iam-login-modal__close",attrs:{"type":"button","aria-label":"关闭登录弹窗"},on:{"click":_vm.handleClose}},[_c('i',{staticClass:"el-icon-close"})]),_vm._v(" "),_c('div',{staticClass:"iam-login-modal__body"},[_c('iframe',{directives:[{name:"show",rawName:"v-show",value:(_vm.loginUrl),expression:"loginUrl"}],ref:"loginFrame",attrs:{"src":_vm.loginUrl,"frameborder":"0","width":"100%","height":"100%"}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loginUrl),expression:"!loginUrl"}],staticClass:"iam-login-modal__loading"},[_c('i',{staticClass:"el-icon-loading"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.loadingText))])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 775:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-wrapper"},[_c('div',{staticClass:"up-wrapper"},[_c('div',{staticClass:"son"},[_c('a',{staticStyle:{"color":"#fff"},attrs:{"href":"javascript:void(0);"},on:{"click":function($event){$event.preventDefault();return _vm.goHealthSite()}}},[_vm._v("\n          健康网\n        ")]),_vm._v(" "),_c('div',{staticClass:"login-wrapper",on:{"click":function($event){return _vm.$router.push('/guide')}}},[_c('span',{staticStyle:{"color":"#fff"}},[_vm._v("服务指南")])]),_vm._v(" "),_c('div',{staticClass:"after-login"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.islogin),expression:"islogin"}],staticClass:"after-son",on:{"click":function($event){return _vm.$router.push('/PersonalInfo')}}},[_c('div',{staticClass:"img-wrapper"},[_c('img',{attrs:{"width":"100%","src":_vm.userInfo&&_vm.userInfo.head}})]),_vm._v(" "),_c('div',{staticClass:"name"},[_vm._v(_vm._s(_vm.userInfo&&_vm.userInfo.userName))]),_vm._v(" "),_c('div',{staticClass:"grade"},[_c('img',{attrs:{"src":_vm.userInfo&&_vm.userInfo.vipIcon}})])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.islogin),expression:"islogin"}],staticClass:"message-icon",on:{"click":function($event){return _vm.$router.push('/PersonalSystem')}}},[(_vm.noReadMessage>0)?_c('el-badge',{staticClass:"item",attrs:{"is-dot":""}},[_c('i',{staticClass:"el-icon-bell"})]):_c('el-badge',{staticClass:"item"},[_c('i',{staticClass:"el-icon-bell"})])],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.islogin),expression:"islogin"}],staticClass:"sign-out",on:{"click":function($event){return _vm.logoOut()}}},[_vm._v("退出")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.islogin),expression:"!islogin"}],staticClass:"login-wrapper"},[_c('span',{staticClass:"line-border",on:{"click":function($event){return _vm.loginAction()}}},[_vm._v("登录")]),_vm._v(" "),_c('span',{on:{"click":function($event){return _vm.openIamRegister()}}},[_vm._v("注册")])])])]),_vm._v(" "),_c('IamLoginModal',{attrs:{"visible":_vm.dialogTableVisible},on:{"close":_vm.closeDialog,"success":_vm.handleIamLoginSuccess}}),_vm._v(" "),_c('div'),_vm._v(" "),_c('el-dialog',{attrs:{"title":"新用户注册","visible":_vm.registerVisible,"width":"400px","center":""},on:{"update:visible":function($event){_vm.registerVisible=$event}}},[_c('div',{staticClass:"sign-wrapper"},[_c('el-form',{ref:"logonForm",staticClass:"demo-logonForm",attrs:{"model":_vm.logonForm,"status-icon":"","rules":_vm.registerRules}},[_c('el-form-item',{attrs:{"prop":"phone"}},[_c('el-input',{attrs:{"type":"text","disableautocomplete":"","autocomplete":"off","placeholder":"请输入手机号"},model:{value:(_vm.logonForm.phone),callback:function ($$v) {_vm.$set(_vm.logonForm, "phone", $$v)},expression:"logonForm.phone"}})],1),_vm._v(" "),_c('div',{staticClass:"code-wrapper"},[_c('el-form-item',{attrs:{"prop":"code"}},[_c('el-input',{attrs:{"type":"text","disableautocomplete":"","autocomplete":"off","placeholder":"请输入验证码"},model:{value:(_vm.logonForm.code),callback:function ($$v) {_vm.$set(_vm.logonForm, "code", $$v)},expression:"logonForm.code"}})],1),_vm._v(" "),_c('div',{staticClass:"code-button"},[_c('div',{staticClass:"send-code",on:{"click":function($event){return _vm.CationCode(_vm.logonForm)}}},[_vm._v(_vm._s(_vm.countText))]),_vm._v(" "),(_vm.codestatus)?_c('div',{staticClass:"mask"}):_vm._e()])],1),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"pass"}},[_c('el-input',{attrs:{"type":"password","disableautocomplete":"","autocomplete":"new-password","placeholder":"请输入6-16位密码"},model:{value:(_vm.logonForm.pass),callback:function ($$v) {_vm.$set(_vm.logonForm, "pass", $$v)},expression:"logonForm.pass"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"passTwo"}},[_c('el-input',{attrs:{"type":"password","disableautocomplete":"","autocomplete":"new-password","placeholder":"确认密码"},model:{value:(_vm.logonForm.passTwo),callback:function ($$v) {_vm.$set(_vm.logonForm, "passTwo", $$v)},expression:"logonForm.passTwo"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"clause"}},[_c('el-checkbox',{model:{value:(_vm.logonForm.clause),callback:function ($$v) {_vm.$set(_vm.logonForm, "clause", $$v)},expression:"logonForm.clause"}},[_vm._v("同意服务条款、隐私政策")]),_vm._v(" "),_c('el-link',{attrs:{"type":"primary","underline":false},on:{"click":function($event){return _vm.$router.push('/clause')}}},[_vm._v("前往隐私政策")])],1),_vm._v(" "),_c('div',{staticClass:"button-wrapper",on:{"click":function($event){return _vm.logonSubmitForm('logonForm')}}},[_vm._v("注册")]),_vm._v(" "),_c('div',{staticClass:"return-wrapper"},[_c('div',{staticClass:"son",on:{"click":function($event){return _vm.goLogin()}}},[_vm._v("返回登录")])])],1)],1)]),_vm._v(" "),_c('el-dialog',{attrs:{"title":"忘记密码","visible":_vm.forgetPwdVisible,"width":"400px","center":""},on:{"update:visible":function($event){_vm.forgetPwdVisible=$event}}},[_c('div',{staticClass:"sign-wrapper"},[_c('el-form',{ref:"forgetPwdForm",staticClass:"demo-logonForm",attrs:{"model":_vm.forgetPwdForm,"status-icon":"","rules":_vm.rules}},[_c('el-form-item',{attrs:{"prop":"phone"}},[_c('el-input',{attrs:{"type":"text","disableautocomplete":"","autocomplete":"off","placeholder":"请输入手机号"},model:{value:(_vm.forgetPwdForm.phone),callback:function ($$v) {_vm.$set(_vm.forgetPwdForm, "phone", $$v)},expression:"forgetPwdForm.phone"}})],1),_vm._v(" "),_c('div',{staticClass:"code-wrapper"},[_c('el-form-item',{attrs:{"prop":"code"}},[_c('el-input',{attrs:{"type":"text","disableautocomplete":"","autocomplete":"off","placeholder":"请输入验证码"},model:{value:(_vm.forgetPwdForm.code),callback:function ($$v) {_vm.$set(_vm.forgetPwdForm, "code", $$v)},expression:"forgetPwdForm.code"}})],1),_vm._v(" "),_c('div',{staticClass:"code-button"},[_c('div',{staticClass:"send-code",on:{"click":function($event){return _vm.CationCode3(_vm.forgetPwdForm)}}},[_vm._v(_vm._s(_vm.countText))]),_vm._v(" "),(_vm.codestatus)?_c('div',{staticClass:"mask"}):_vm._e()])],1),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"pass"}},[_c('el-input',{attrs:{"type":"password","disableautocomplete":"","autocomplete":"new-password","placeholder":"请输入6-16位密码"},model:{value:(_vm.forgetPwdForm.pass),callback:function ($$v) {_vm.$set(_vm.forgetPwdForm, "pass", $$v)},expression:"forgetPwdForm.pass"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"passTwo"}},[_c('el-input',{attrs:{"type":"password","disableautocomplete":"","autocomplete":"new-password","placeholder":"确认密码"},model:{value:(_vm.forgetPwdForm.passTwo),callback:function ($$v) {_vm.$set(_vm.forgetPwdForm, "passTwo", $$v)},expression:"forgetPwdForm.passTwo"}})],1),_vm._v(" "),_c('div',{staticClass:"button-wrapper",on:{"click":function($event){return _vm.forgetPwdSubmitForm('forgetPwdForm')}}},[_vm._v("找回密码")]),_vm._v(" "),_c('div',{staticClass:"return-wrapper"},[_c('div',{staticClass:"son",on:{"click":function($event){return _vm.goLogin()}}},[_vm._v("返回登录")])])],1)],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 776:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_footer_vue__ = __webpack_require__(356);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_401b5fda_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_footer_vue__ = __webpack_require__(778);
function injectStyle (ssrContext) {
  __webpack_require__(777)
}
var normalizeComponent = __webpack_require__(102)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-401b5fda"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_footer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_401b5fda_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_footer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 777:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 778:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"son"},[_c('div',{staticClass:"l"},[_c('ul',{staticClass:"ul-wrapper"},[_vm._l((_vm.navListTop),function(item,index){return [(index)?_c('span',{staticClass:"I"},[_vm._v("|")]):_vm._e(),_vm._v(" "),_c('li',{staticClass:"item"},[(index===0)?_c('a',{attrs:{"href":item.link}},[_vm._v(_vm._s(item.name))]):_c('a',{attrs:{"href":item.link,"target":"_blank"}},[_vm._v(_vm._s(item.name))])])]})],2),_vm._v(" "),_c('ul',{staticClass:"ul-wrapper"},[_vm._l((_vm.navlist),function(item,index){return [(index)?_c('span',{staticClass:"I"},[_vm._v("|")]):_vm._e(),_vm._v(" "),_c('li',{staticClass:"item",on:{"click":function($event){return _vm.linkFun(item)}}},[_vm._v(_vm._s(item.name))])]})],2),_vm._v(" "),_c('div',{staticClass:"info"},[_c('p',[_vm._v("版权所有：健康网")]),_vm._v(" "),_c('p',[_vm._v("北京东方比特科技有限公司")]),_vm._v(" "),_c('p',[_c('el-link',{staticStyle:{"color":"white"},attrs:{"href":"https://beian.miit.gov.cn","target":"_blank","underline":false}},[_vm._v("\n            京ICP证010450号\n          ")])],1),_vm._v(" "),_c('p',[_vm._v("京卫网审字：[2001]第22号")]),_vm._v(" "),_c('p',[_vm._v("互联网药品信息服务：(京)-经营性-2015-0016")]),_vm._v(" "),_c('p',[_c('el-link',{staticStyle:{"color":"white"},attrs:{"href":"http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010202000260","target":"_blank","underline":false}},[_vm._v("京公网安备：110102000260\n          ")])],1),_vm._v(" "),_c('p',[_vm._v("联系电话：010-68012929")])])]),_vm._v(" "),_vm._m(0)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"r"},[_c('img',{attrs:{"src":__webpack_require__(779)}}),_vm._v(" "),_c('div',{staticClass:"text"},[_vm._v("健康网微信公众号")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 779:
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),

/***/ 780:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('span',{staticStyle:{"position":"absolute","left":"0","top":"0","visibility":"hidden"},attrs:{"id":"ty-computeWidth-th"}}),_vm._v(" "),[_c('transition',{attrs:{"name":"el-fade-in-linear"}},[_c('Header')],1),_vm._v(" "),_c('transition',{attrs:{"name":"el-fade-in-linear"}},[_c('router-view')],1),_vm._v(" "),(_vm.adsList.side)?[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.adsLeftShow),expression:"adsLeftShow"}],staticStyle:{"position":"fixed","top":"30%","width":"100px","height":"300px","z-index":"999"}},[_c('a',{attrs:{"href":_vm.adsList.side[0].link,"target":"_blank"}},[_c('img',{staticStyle:{"width":"100%","height":"100%"},attrs:{"src":_vm.adsList.side[0].image}})]),_vm._v(" "),_c('div',{staticClass:"ads-close-text",on:{"click":function($event){_vm.adsLeftShow = false}}},[_vm._v("关闭")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.adsRightShow),expression:"adsRightShow"}],staticStyle:{"position":"fixed","top":"30%","right":"0","width":"100px","height":"300px","z-index":"999"}},[_c('a',{attrs:{"href":_vm.adsList.side[1].link,"target":"_blank"}},[_c('img',{staticStyle:{"width":"100%","height":"100%"},attrs:{"src":_vm.adsList.side[1].image}})]),_vm._v(" "),_c('div',{staticClass:"ads-close-text",on:{"click":function($event){_vm.adsRightShow = false}}},[_vm._v("关闭")])])]:_vm._e(),_vm._v(" "),_c('transition',{attrs:{"name":"list","tag":"p"}},[(_vm.adsList.bottom)?_c('div',{staticClass:"list-item"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.adsBotoomShow),expression:"adsBotoomShow"}],staticStyle:{"height":"80px","position":"relative"}},[_c('i',{staticClass:"el-icon-error",staticStyle:{"position":"absolute","right":"10px","top":"5px","color":"#014099"},on:{"click":function($event){_vm.adsBotoomShow = false}}}),_vm._v(" "),_c('a',{attrs:{"href":_vm.adsList.bottom.link,"target":"_blank"}},[_c('img',{staticStyle:{"width":"100%","height":"100%"},attrs:{"src":_vm.adsList.bottom.image}})])])]):_vm._e()]),_vm._v(" "),_c('transition',{attrs:{"name":"el-fade-in-linear"}},[_c('Footer')],1)]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 781:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(782);


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  // routes:routes,
  // base: process.env.BASE_URL,
  base: '/',
  routes: [{
    path: '/',
    component: function component() {
      return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 1089));
    }
  }, {
    path: '/SearchList',
    component: function component() {
      return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 1090));
    },
    name: '产品名录结果',
    meta: { title: "产品名录结果" }
  }, {
    path: '/ShoppingCart',
    component: function component() {
      return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, 1091));
    }
  }, {
    path: '/ShoppingOrder',
    component: function component() {
      return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, 1092));
    }
  }, {
    path: '/payGateWay',
    component: function component() {
      return __webpack_require__.e/* import() */(22).then(__webpack_require__.bind(null, 1093));
    }
  }, {
    path: '/ShoppingCompleted',
    component: function component() {
      return __webpack_require__.e/* import() */(19).then(__webpack_require__.bind(null, 1094));
    }
  }, {
    path: '/ShoppingWait',
    component: function component() {
      return __webpack_require__.e/* import() */(18).then(__webpack_require__.bind(null, 1095));
    }
  }, {
    path: '/clause',
    component: function component() {
      return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 1096));
    }
  }, {
    path: '/guide',
    component: function component() {
      return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 1097));
    }
  }, {
    path: '/page',
    component: function component() {
      return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 1098));
    },
    name: "page",
    // redirect: '@/pages/page/table',
    children: [{
      path: '/table',
      component: function component() {
        return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 1099));
      },
      name: 'tablePage'
    }, {
      path: '/table2',
      component: function component() {
        return __webpack_require__.e/* import() */(21).then(__webpack_require__.bind(null, 1100));
      }
    }, {
      path: '/download',
      component: function component() {
        return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 1101));
      },
      name: "download"
    }]
  }, {
    path: '/Personal',
    component: function component() {
      return __webpack_require__.e/* import() */(20).then(__webpack_require__.bind(null, 1102));
    },
    name: '个人中心',
    meta: { title: "个人中心",
      requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
    },
    redirect: '/PersonalInfo',
    children: [{
      path: '/PersonalInfo',
      component: function component() {
        return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 1103));
      },
      name: '个人信息',
      meta: { title: "个人信息",
        requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
      }
    }, {
      path: '/PersonalService',
      component: function component() {
        return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, 1104));
      },
      // name: '服务项目',
      //meta: { title: "服务项目" ,
      name: '服务指南',
      meta: { title: "服务指南",
        requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
      }
    }, {
      path: '/PersonalBkService',
      component: function component() {
        return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, 1105));
      },
      name: '包库管理',
      meta: { title: "包库管理",
        requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
      }
    },
    // {
    //   path: '/Personal/PersonalBrowse',
    //   component: ()=>import('@/pages/personal/PersonalBrowse'),
    //   name:'服务项目',
    //   meta:{title:"服务项目"}
    // },
    {
      path: '/PersonalIntegral',
      component: function component() {
        return __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, 1106));
      },
      name: '积分管理',
      meta: { title: "积分管理",
        requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
      }
    }, {
      path: '/PersonalOrder',
      component: function component() {
        return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 1107));
      },
      name: '我的订单',
      meta: { title: "我的订单",
        requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
      }
    }, {
      path: '/PersonalControl',
      component: function component() {
        return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 1108));
      },
      name: '发票管理',
      meta: { title: "发票管理",
        requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
      }
    }, {
      path: '/PersonalContract',
      component: function component() {
        return __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, 1109));
      },
      name: '合同管理',
      meta: { title: "合同管理",
        requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
      }
    }, {
      path: '/PersonalAccount',
      component: function component() {
        return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 1110));
      },
      name: '子账号管理',
      meta: { title: "子账号管理",
        requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
      }
    }, {
      path: '/PersonalSystem',
      component: function component() {
        return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, 1111));
      },
      name: '消息管理',
      meta: { title: "消息管理",
        requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
      }
    }, {
      path: '/PersonalSystemDel',
      component: function component() {
        return __webpack_require__.e/* import() */(24).then(__webpack_require__.bind(null, 1112));
      },
      name: '消息详情管理',
      meta: { title: "消息详情管理",
        requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
      }
    }]
  }, {
    path: '/login',
    component: function component() {
      return __webpack_require__.e/* import() */(25).then(__webpack_require__.bind(null, 1113));
    }
  }, {
    path: '/qclink',
    component: function component() {
      return __webpack_require__.e/* import() */(23).then(__webpack_require__.bind(null, 1114));
    }
  }, {
    path: '*',
    redirect: '/'
  }]
}));

/***/ }),

/***/ 783:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 784:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[441]);


// WEBPACK FOOTER //
// static/js/app.337381d88920374da227.js